import React, {useRef, useState} from "react";
import {useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/main/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIInputMask from 'components/input/UIInputMask';
import UIDatePicker from "components/datepicker";
import useToggleState from 'components/hooks/useToggleState';
import {Tooltip} from "react-tooltip";
import ModalPopup from 'components/modal/';
import DateUtil from "utils/DateUtil";
import CommonUtil from "utils/CommonUtil";
import StringUtil from "utils/StringUtil";
import UITextArea from "components/atoms/textarea/UITextArea";
import UISelect from "components/selectbox/UISelect";
import UIUtils from "utils/UIUtils";
import codeDataStore from "common/codedata/store/CodeDataStore";
import PageLoading from "../../../../components/loading";
import TbComFile from "domain/main/com/file/TbComFile";
import UI from "../../../../components/UI";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
import {CodeData} from "../../../../common/codedata/source/CodeDataSource";

type FileInfoType = {
	FILE_DETAIL_ID?:string;
	ORGINL_FILE_NM:string;
	STRE_FILE_NM:string;
	FILE_SIZE:number;
	STRE_PATH:string;
	FILE_EXTSN:string;
	FILE_GB:string;
	FILE_STATUS?:string;
};

function ContentsContainer() {
	// const [codeLoading2Args, setCodeLoading2Args] = useState<string[]>();
	// const [codeLoading2, codeResolved2, codeError2] = usePromise(codeDataStore.read, codeLoading2Args, []);

	const location = useLocation();
	const history = useHistory();
	const receivedData = (location.state as any)?.data;
	let info = receivedData.REC1[0];

	let modal2139Cols = [
		{"Header": "No","Type": "Int", "Name": "RN","Align": "Center","RelWidth": 0.5,"CanEdit": "0"},
		{"Header": "출연사업","Type": "Text","Name": "BIZ_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
		{"Header": "출연금액(원)","Type": "Int","Name": "REMAIN_DON_AMT","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
		{"Header": "선택","Type": "Html","Name": "SELECT","RelWidth": 2,"Align": "Center" , "HtmlPostfix" : '<button class="bt" data-color="pri" data-size="tn" type="button" >선택</button>'}
	];

	let modal2102Cols = [
		{"Header": { "Value": "", "Align": "Center", "IconAlign": "Center" },"Type": "Bool", "Name": "sCheckBox","Align": "Center","RelWidth": 0.5,"CanEdit": "1", "BoolIcon": 4, "CanSort": 0},
		{"Header": "사업자등록번호","Type": "Text","Name": "BIZ_NO","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"},
		{"Header": "수행기관","Type": "Text","Name": "CORP_NM","RelWidth": 2,"Align": "Center" ,"CanEdit": "0"}
	];

	let sheetId = useRef<string>("");
	let sheetCols = useRef<any>([]);

	//파일정보 선언
	const [reqFileNm, setReqFileNm] = useState('');
	const [planFileNm, setPlanFileNm] = useState('');
	const [bizFileNm, setBizFileNm] = useState('');

	const [rightCorpList,setRightCorpList] = useState([]); //선택한 수행기관 시트 데이터

	const [corpLogoFileValue] = useState(new TbComFile());
	//const [bizLicFileValue] = useState(new TbComFile());
	const [fileValue] = useState(new TbComFile());
	const [bizLicFileValue, setBizLicFileValue] = useState(new TbComFile());

	// REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
	const [reqFileValue] = useState(new TbComFile());
	const [planFileValue] = useState(new TbComFile());
	const [bizFileValue] = useState(new TbComFile());
	const [otherFiles] = useState(new TbComFile());

	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [uploadComp2103, setUploadComp2103] = useState(false);
	const [uploadComp2104, setUploadComp2104] = useState(false);
	const [fileInfoList2103, setFileInfoList2103] = React.useState<any[]>([]);
	const [fileInfoList2104, setFileInfoList2104] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);
	
	const [isAllChk,setIsAllChk] = useState(false); //전체체크 여부
	const [isAllChk2,setIsAllChk2] = useState(false); //추가승인신청 전체체크 여부
	//파일업로드
	const [uploadId, setUploadId] = React.useState("");
	const [uploadId2103, setUploadId2103] = React.useState("");
	const [uploadId2104, setUploadId2104] = React.useState("");

	//2102 수행기관찾기(검색) = 2105 , 2103 수행기관 신규, 2104 수행기관 수정
	const [modal2139IsOpen, setModal2139IsOpen] = useState(false);
	const [modal2102IsOpen, setModal2102IsOpen] = useState(false);
	const [modal2103IsOpen, setModal2103IsOpen] = useState(false);
	const [modal2104IsOpen, setModal2104IsOpen] = useState(false);

	const [loadFinish,setLoadFinish] = useState(false);

	const defaultState = {
		REC: [],
		selectBiz : {},
		selectReaminDonAmt: 0,
		reaminDonAmt: 0,
		rightCorpList: [],
		selectCorpList: undefined as any,
		bizNo2102: '',
		selectBizNo2102: '',
		corpNm2102: '',//팝업 회사이름 검색용
		open2102: '', //수행기관 선택 select
		corpNm2103: '',
		bizNo2103: '',
		ceoNm2103: '', //
		estaDate2103: new Date(),
		corpSizeCd2103: '',
		induCd2103: '',
		emailAdres2103:'', //기업규모
		personNm2103:'', //
		ofcTelNo2103:'', //
		hpNo2103:'', //
		fileId2103:'', //
		estaFormCd2103:'', //
		corpNm2104:'', //
		bizNo2104: '', //
		ceoNm2104: '', //
		estaDate2104:new Date(), //
		corpSizeCd2104:'', //
		induCd2104:'', //
		emailAdres2104:'', //기업규모
		personNm2104: '', //
		ofcTelNo2104: '', //
		hpNo2104: '', //
		fileId2104: '', //
		estaFormCd2104:'', //
		donBizNo2104:'', //
		history2104:[] as { [key:string]:string }[], //
		corpList:[],
		corpListText:'',
		TSK_REQ_NO:'', //과제번호
		TSK_REQ_MODI_SEQ:'', //과제번호
		tskCloDate:'', //과제기간 종료
		tskPeriod:'', //과제기간 월일 표기
		suppContDivNm:'', //기금사용용도
		tskReqStsNm: '', //과제명
		tskReqStsCd: '', //과제명
		subYn: 'N', //제출여부
		cloYn: 'N', //종료여부
		tskReqDate: '', //과제수정번호
		oldTskInfo: {} as any,
		bizCd: '',
		tskBizCd: '',
		tskBizNo: '',
		totalRowCnt: 0,
		showRowCnt: 20, //기본 row count
		amtList: [{ SUPP_ITEM : '', CALC_BASIS : '', PROF_MATH : '', SUPP_AMT : 0, num : 0 , checked : false}],
		addAmtList: [{ ADD_SUPP_ITEM : '', ADD_CALC_BASIS : '', ADD_PROF_MATH : '', ADD_SUPP_AMT : 0, num : 0 , checked : false}],
		nextNum: 1, //amtList 고유 key
		addNextNum: 1,
		totalAmt: 0, //금액 총액
		addTotalAmt: 0, 
		elecApprYn: info.ELEC_APPR_YN, //전자인증 여부
		fileId: '',
		elec: '',
		tskStDate: new Date(), //과제기간 시작
		tskEnDate: new Date(new Date().getFullYear()+'-12-31'), //과제기간 종료
		funPurUseNm: '', //기금사용용도
		funPurUseNo: '1',
		bizKindNm1: '', //과제분류 대
		bizKindNm2: '', //과제분류 소
		bizKindCd1: '', //과제분류 대 코드
		bizKindCd2: '', //과제분류 소 코드
		fpucList: [], //과제분류 대 코드
		bizKindCd1List: [] as CodeData[], //과제분류 대 코드
		bizKindCd2List: [] as CodeData[], //과제분류 소 코드
		funPurUseCd: '', //기부금 사용용도
		isUA: false, //지원금액변경 여부
		isUD: false, //지원기간 여부
		isUE: false, //기타변경사유 여부
		isOpen: '', //기타변경사유 여부
		judgeCmtUA: '', //지원금액변경 사유
		judgeCmtUD: '', //지원기간변경 사유
		judgeCmtUE: '', //지원기간변경 사유
		bizNm: '', //사업명
		tskNm: '', //과제명
		suppCorpCnt: 0, //중소기업 지원수
		otherSuppCorpCnt: 0, //중소기업 외 지원수
		corpNm: '', //과제명
		bizNo: '', //사업자번호
		corpRegNo: '', //사업자번호
		personNm: '', //이름
		personId: '', //
		posiNm: '', //직급
		deptNm: '', //부서명
		emailAdres: '', //이메일
		ofcTelNo: '', //전화번호
		suppCont: '', //지원내용, 과제개요 // as-is, to-be
		exeEffDesc: '', //기대효과, 정성내용 // as-is, to-be
		qList: { //기대효과 14문항
			q1: '', q2: '', q3: '', q4: '', q5: '', q6: '', q7: '', q8: '', q9: '', q10: '', q11: '', q12: '', q13: '', q14: ''
		},
		queList: [] as any,
		reqFileNm: '',
		planFileNm: '',
		bizFileNm: '',
		corpLogoFileValue: new TbComFile(),
		bizLicFileValue: new TbComFile(),
		fileValue: new TbComFile(),
		reqFileValue: new TbComFile(),
		planFileValue: new TbComFile(),
		bizFileValue: new TbComFile(),
		otherFiles: new TbComFile(),
		uploadComp: false,
		fileInfoList: [] as FileInfoType[],
		uploadComp2103: false,
		uploadComp2104: false,
		fileInfoList2103: [] as FileInfoType[],
		fileInfoList2104: [] as FileInfoType[],
		fileInfoListPop: [] as FileInfoType[],
		uploadId: "",
		uploadId2103: "",
		uploadId2104: "",
		foreTskYn: ''
	}

	const [state, setState] = useState((() => {
		const result = receivedData;
		console.log(result)
		let info = result.REC1[0];

		let elecNm = "";
		if(info.ELEC_APPR_YN == 'Y'){
			elecNm = "전자인증";
		}else if(info.FILE_ID != null){
			elecNm = "서면"
		}else{
			elecNm="미제출";
		}

		let qJson = {...defaultState.qList};
		let question = info.QUESTION;
		if(question != null){
			let list = question.split('^||^');
			for(let i = 0; i < list.length; i++){
				qJson['q'+(i+1)] = list[i];
			}
		}

		const open2102 = result.REC2.length != 0
		const selectCorpList = open2102 ? result.REC2.map((value:any) => {
			return value.CORP_NM
		}).join(',') : '';

		let reqFileNm = "";
		let planFileNm = "";
		let bizFileNm = "";
		let fileList = result.FILE_INFO;
		
		let personNm = "";
		let deptNm = "";
		let posiNm = "";
		let emailAdres = "";
		let ofcTelNo = "";
		
		if(info.TSK_PIC_PERSON_NM != null && info.TSK_PIC_PERSON_NM != ''){
			personNm = info.TSK_PIC_PERSON_NM;
	  		deptNm = info.TSK_PIC_DEPT_NM; 
	  		posiNm = info.TSK_PIC_POSI_NM; 
			emailAdres = info.TSK_PIC_EMAIL_ADRES; 
	 		ofcTelNo = info.TSK_PIC_OFC_TEL_NO; 		
		}else{
			personNm = receivedData.PERSON_NM;
	  		deptNm = receivedData.DEPT_NM; 
	  		posiNm = receivedData.POSI_NM; 
			emailAdres = receivedData.EMAIL_ADRES; 
	 		ofcTelNo = receivedData.OFC_TEL_NO;
		}

		receivedData.REC2.forEach((v) => {
			v['REAL_BIZ_NO'] = '' + (v.BIZ_NO).replace(/-/ig, '');
		});
		
		
		let addAmtList =[...defaultState.addAmtList]
		
		if(receivedData.REC4.length > 0){
			addAmtList = receivedData.REC4 			
		}
		
		return {
			...defaultState,
			elec: elecNm,
			fileId: info.FILE_ID,
			oldTskInfo: info,
			tskBizNo: info.BIZ_NO,
			tskBizCd: info.BIZ_CD,
			TSK_REQ_NO: info.TSK_REQ_NO,
			TSK_REQ_MODI_SEQ: info.TSK_REQ_MODI_SEQ,
			foreTskYn: info.FORE_TSK_YN,
			tskStDate: new Date(Number(info.TSK_ST_DATE)),
			tskEnDate: new Date(Number(info.TSK_EN_DATE)),
			tskCloDate: dateToStr(info.TSK_CLO_DATE),
			tskPeriod: info.TSK_PERIOD,
			bizKindNm1: info.BIZ_KIND_NM_1,
			bizKindCd1List: codeDataStore.get("common.suppSizeA," + info.FUN_PUR_USE_NO),
			bizKindNm2: info.BIZ_KIND_NM_2,
			bizKindCd2List: codeDataStore.get("common.suppSizeB," + info.FUN_PUR_USE_NO + "," + info.BIZ_KIND_CD_1),
			funPurUseCd: info.FUN_PUR_USE_CD,
			funPurUseNo: info.FUN_PUR_USE_NO,
			bizKindCd1: info.BIZ_KIND_CD_1,
			bizKindCd2: info.BIZ_KIND_CD_2,
			suppContDivNm: info.SUPP_CONT_DIV_NM,
			bizNm: info.BIZ_NM,
			tskNm: info.TSK_NM,
			suppCorpCnt: info.SUPP_CORP_CNT,
			otherSuppCorpCnt: info.OTHER_SUPP_CORP_CNT,
			tskReqDate: dateToStr(info.TSK_REQ_DATE),
			subYn: info.SUB_YN,
			cloYn: info.TSK_CLO_YN,
			tskReqStsNm: info.TSK_REQ_STS_NM,
			tskReqStsCd: info.TSK_REQ_STS_CD,
			suppCont: info.SUPP_CONT,
			exeEffDesc: info.EXE_EFF_DESC,
			totalAmt: Number(info.TOT_AMT),
			addTotalAmt: Number(info.ADD_TOT_AMT),
			reaminDonAmt: Number(receivedData.REMAIN_DON_AMT) + Number(info.TOT_AMT),
			selectReaminDonAmt: Number(receivedData.REMAIN_DON_AMT) + Number(info.TOT_AMT),
			corpNm: receivedData.CORP_NM,
			bizNo: receivedData.BIZ_NO,
			corpRegNo: receivedData.CORP_REG_NO,
			personId: receivedData.PERSON_ID,

			personNm: personNm,
			posiNm: posiNm,
			deptNm: deptNm,
			emailAdres: emailAdres,
			ofcTelNo: ofcTelNo,

			amtList: receivedData.REC3,
			addAmtList: addAmtList,
			corpList: receivedData.REC2,
			qList: qJson,
			queList: receivedData.QUE_LIST,
			open2102: open2102?'open':"",
			selectCorpList: selectCorpList,
			reqFileNm: reqFileNm,
			planFileNm: planFileNm,
			bizFileNm: bizFileNm,
			reqFileValue: reqFileValue,
			planFileValue: planFileValue,
			bizFileValue: bizFileValue,
			otherFiles: otherFiles,
			REC: receivedData.REC66
		}
	})());

	function dateToStr(dateText) {
		if(dateText == null) return '';
		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');
		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}
		return num;
	}

	const handleChange = (e) => {
		if(e.target.name === 'open2102Sel') {
			if(e.target.value == 'open'){
				setModal2102IsOpen(true);
				setState({...state, open2102: e.target.value})
			} else{
				setRightCorpList([]);
				//@ts-ignore
				setState({...state, open2102: e.target.value, selectCorpList: ''})
			}

		}else{
			setRightCorpList([]);
			//@ts-ignore
			setState({...state, selectCorpList: ''})
		}
	}

	const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		var id = event.target.id;
		if(id === 'rd-1-1') {
			setState({...state, foreTskYn:'N'});
		}else if(id === 'rd-1-2') {
			setState({...state, foreTskYn:'Y'});
		}
	};

	//파일업로드
    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }
	//파일업로드
    const onCreationComplete2103 = function (uploadID: string) {
        setUploadId2103(uploadID);
    }
	//파일업로드
    const onCreationComplete2104 = function (uploadID: string) {
        setUploadId2104(uploadID);
    }

	//파일업로드 완료
	const onUploadComplete = () => {
		const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
		console.log("arrayNew " ,JSON.stringify(arrayNew));

		let fileInfos : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		}[] = [];

		let fileInfo : {
			FILE_DETAIL_ID:string;
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
			FILE_STATUS:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					FILE_DETAIL_ID:item.uniqKey,
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
					FILE_GB:"",
					FILE_STATUS:"ADD"
				}
				fileInfos.push(fileInfo);
			}

			console.log("fileInfos : "+JSON.stringify(fileInfos));
		})

		//파일등록 정보
		arrayDel?.forEach((item, index) => {
			fileInfo = {
				FILE_DETAIL_ID:item.uniqKey,
				ORGINL_FILE_NM:item.originalName,
				STRE_FILE_NM:item.uploadName,
				FILE_SIZE:item.size,
				STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
				FILE_EXTSN:item.extension,
				FILE_GB:"",
				FILE_STATUS:"DEL"
			}
			fileInfos.push(fileInfo);
		})

		setFileInfoList(fileInfos);
		setUploadComp(true);
    }


	//파일업로드 완료
	const onUploadComplete2103 = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId2103);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
		console.log("arrayNew " ,JSON.stringify(arrayNew));

		let fileInfos : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
		}[] = [];

		let fileInfo : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
					FILE_GB:""
				}
				fileInfos.push(fileInfo);
			}
			console.log("fileInfos : "+JSON.stringify(fileInfos));
		})

		setFileInfoList2103(fileInfos);
		setUploadComp2103(true);
    }

	//파일업로드 완료
	const onUploadComplete2104 = () => {
        const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId2104);
        const arrayNew = dataArray.newFile;
        const arrayDel = dataArray.deleteFile;
	    console.log("arrayNew " ,JSON.stringify(arrayNew));

		let fileInfos : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
		}[] = [];

		let fileInfo : {
			ORGINL_FILE_NM:string;
			STRE_FILE_NM:string;
			FILE_SIZE:number;
			STRE_PATH:string;
			FILE_EXTSN:string;
			FILE_GB:string;
		};

		//파일등록 정보
		arrayNew?.map((item, index) => {
			if(item.status =="complete"){
				fileInfo = {
					ORGINL_FILE_NM:item.originalName,
					STRE_FILE_NM:item.uploadName,
					FILE_SIZE:item.size,
					STRE_PATH:"/" + item.uploadPath.split("/").reverse().slice(1, 3).reverse().join("/") ,
					FILE_EXTSN:item.extension,
					FILE_GB:""
				}
				fileInfos.push(fileInfo);
			}
			console.log("fileInfos : "+JSON.stringify(fileInfos));
		})

		setFileInfoList2104(fileInfos);
		setUploadComp2104(true);
    }

	async function onFileUpload()  {
		if(uploadId){
			await window["RAONKUPLOAD"].Transfer(uploadId);
		}
	}
	async function onFileUpload2103()  {
		if(uploadId2103){
			await window["RAONKUPLOAD"].Transfer(uploadId2103);
		}
	}
	async function onFileUpload2104()  {
		if(uploadId2104){
			await window["RAONKUPLOAD"].Transfer(uploadId2104);
		}
	}

	React.useEffect(() => {
		if(uploadComp){
			saveTsk(uploadComp);
		}
	},[uploadComp])

	React.useEffect(() => {
		if(uploadComp2103){
			saveCorp(uploadComp2103);
		}
	},[uploadComp2103])

	React.useEffect(() => {
		if(uploadComp2104){
			updateCorp(uploadComp2104);
		}
	},[uploadComp2104])

	function changeVal(val, type, index){
		let newList = [...state.amtList];

		if(type == 'amt'){
			newList[index].SUPP_AMT = val;
		}else if(type == 'item'){
			newList[index].SUPP_ITEM = val;
		}else if(type == 'basis'){
			newList[index].CALC_BASIS = val;
		}else if(type == 'math'){
			newList[index].PROF_MATH = val;
		}else if(type == 'checked'){
			newList[index].checked = val;
		}

		if(type == 'amt'){
			let sum = newList.reduce((total, amt) => {
				return Number(amt.SUPP_AMT) + total
			}, 0);
			setState({...state, amtList: newList, totalAmt: sum})
		}
		else {
			setState({...state, amtList: newList})
		}

		console.log('type : ' + type)
		console.log('val : ' + val)
	}

	function addList(){
		const nextAmt = state.amtList.concat({
			SUPP_ITEM : '', CALC_BASIS : '', PROF_MATH : '', SUPP_AMT : 0, num : 0 , checked : false
		});
		setState({...state, nextNum: (state.nextNum + 1), amtList: nextAmt})
	}

	function deleteList(){
		let newList = state.amtList.filter(function(data) {
			return !data.checked
		});

		if(newList.length != 0){
			let sum = newList.reduce((total, amt) => {
				return Number(amt.SUPP_AMT) + total
			}, 0);
			setState({...state, totalAmt: sum, amtList: newList})
		}else{
			//전체 삭제시 초기화
			newList = [{ SUPP_ITEM : '', CALC_BASIS : '', PROF_MATH : '', SUPP_AMT : 0, num : 0 , checked : false}];
			setState({...state, amtList: newList, totalAmt: 0, nextNum: 1})
			setIsAllChk(false);
		}
	}

	function isChecked(element)  {
		if(element.checked == false)  {
			return true;
		}
	}
	

	const checkBoxHandler = (e) => {
		//체크박스 제어
		if(e.target.name === 'ch-all'){
			setIsAllChk(e.target.checked);
		} else {
			let numReg = /[^0-9]/g;
			let name = e.target.name;
			let index = name.replace(numReg, '');
			//값변경 제어
			changeVal(e.target.checked, 'checked', index);
		}

		//전체체크 확인
		if(e.target.name != 'ch-all'){
			let isAll = false;

			//false가 없는지 체크
			if(state.amtList.find(isChecked) == undefined){
				isAll = true;
			}
			setIsAllChk(isAll);

		}else{
			let newList = [...state.amtList];
			let allCheckBol = e.target.checked;
			newList = newList.map(e => {
				e.checked = allCheckBol;
				return e;
			});
			setState({...state, amtList: newList})
		}
	};
	////////////////////////////
	function changeVal2(val, type, index){
		let newList = [...state.addAmtList];

		if(type == 'amt'){
			newList[index].ADD_SUPP_AMT = val;
		}else if(type == 'item'){
			newList[index].ADD_SUPP_ITEM = val;
		}else if(type == 'basis'){
			newList[index].ADD_CALC_BASIS = val;
		}else if(type == 'math'){
			newList[index].ADD_PROF_MATH = val;
		}else if(type == 'checked'){
			newList[index].checked = val;
		}

		if(type == 'amt'){
			let sum = newList.reduce((total, amt) => {
				return Number(amt.ADD_SUPP_AMT) + total
			}, 0);
			setState({...state, addAmtList: newList, addTotalAmt: sum})
		}
		else {
			setState({...state, addAmtList: newList})
		}

		console.log('type : ' + type)
		console.log('val : ' + val)
	}

	function addList2(){
		const nextAmt = state.addAmtList.concat({
			ADD_SUPP_ITEM : '', ADD_CALC_BASIS : '', ADD_PROF_MATH : '', ADD_SUPP_AMT : 0, num : 0 , checked : false
		});
		setState({...state, addNextNum: (state.addNextNum + 1), addAmtList: nextAmt})
	}

	function deleteList2(){
		let newList = state.addAmtList.filter(function(data) {
			return !data.checked
		});

		if(newList.length != 0){
			let sum = newList.reduce((total, amt) => {
				return Number(amt.ADD_SUPP_AMT) + total
			}, 0);
			setState({...state, addTotalAmt: sum, addAmtList: newList})
		}else{
			//전체 삭제시 초기화
			newList = [{ ADD_SUPP_ITEM : '', ADD_CALC_BASIS : '', ADD_PROF_MATH : '', ADD_SUPP_AMT : 0, num : 0 , checked : false}];
			setState({...state, addAmtList: newList, addTotalAmt: 0, addNextNum: 1})
			setIsAllChk2(false);
		}
	}

	const addCheckBoxHandler = (e) => {
		//체크박스 제어
		if(e.target.name === 'ch-all2'){
			setIsAllChk2(e.target.checked);
		} else {
			let numReg = /[^0-9]/g;
			let name = e.target.name;
			let index = name.replace(numReg, '');
			//값변경 제어
			changeVal2(e.target.checked, 'checked', index);
		}

		//전체체크 확인
		if(e.target.name != 'ch-all2'){
			let isAll = false;

			//false가 없는지 체크
			if(state.addAmtList.find(isChecked) == undefined){
				isAll = true;
			}
			setIsAllChk2(isAll);

		}else{
			let newList = [...state.addAmtList];
			let allCheckBol = e.target.checked;
			newList = newList.map(e => {
				e.checked = allCheckBol;
				return e;
			});
			setState({...state, addAmtList: newList})
		}
	};

	const checkBoxHandlerChange = (e) => {
		//체크박스 제어
		if(e.target.id === 'ch-1'){
			setState({...state, isUA: e.target.checked})
		}else if(e.target.id === 'ch-2'){
			setState({...state, isUD: e.target.checked})
		}else if(e.target.id === 'ch-3'){
			setState({...state, isUE: e.target.checked})
		}
	};

	//페이지 건수별로 보기
	const handleSelect = (e) => {
		/*if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);
			// @ts-ignore
			IBSheet.disposeAll(true);
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();

		}else if(e.target.name === 'donProcStsCd'){
			setDonProcStsCd(e.target.value);
		}else if(e.target.name === 'bizNm'){
			setBizNm(e.target.value);
		}else if(e.target.name === 'receipt'){
			setReceipt(e.target.value);
		}*/
	};

	function resetData(num){
		if(num == '2103'){
			setState({...state,
				corpNm2103: '',
				bizNo2103: '',
				ceoNm2103: '',
				estaDate2103: new Date(),
				corpSizeCd2103: '',
				induCd2103: '',
				emailAdres2103: '',
				personNm2103: '',
				ofcTelNo2103: '',
				hpNo2103: '',
				estaFormCd2103: '',
				uploadId2103: '',
				fileInfoList2103: []
			})
			setUploadId2103('');
			setFileInfoList2103([]);
		}else if(num == '2104'){
			setState({
				...state,
				corpNm2104: '',
				bizNo2104: '',
				ceoNm2104: '',
				estaDate2104: new Date(),
				corpSizeCd2104: '',
				induCd2104: '',
				emailAdres2104: '',
				personNm2104: '',
				ofcTelNo2104: '',
				hpNo2104: '',
				estaFormCd2104: '',
				uploadId2104: '',
				fileInfoList2104: []
			})
			setUploadId2104('');
			setFileInfoList2104([]);
		}
	}

	async function onClose(num) {
		if(num == '2139'){
			setModal2139IsOpen(false);
			// @ts-ignore
			IBSheet.sheet_modal.dispose();
		}else if(num == '2102'){
			setModal2102IsOpen(false);
			// @ts-ignore
			IBSheet.sheet_modal.dispose();
			// @ts-ignore
			IBSheet.sheet_modal_right.dispose();
		}else if(num == '2103'){
			setModal2103IsOpen(false);
		}else if(num == '2104'){
			setModal2104IsOpen(false);
		}

		resetData(num);
	}

	async function onAfterOpen(num) {
		if(num == '2139'){
			sheetId.current = 'modal_2139_List';
			sheetCols.current = modal2139Cols;
		}else if(num == '2102') {
			sheetId.current = 'modal_2102_List';
			sheetCols.current = modal2102Cols;
		}else if(num == '2103'){
			return;
		}else if(num == '2104'){
			return;
		}

		ib_modal.create();

		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	}

	//초기 데이터 설정
	let totalCnt:number = 0;
	let totalCntRight:number = 0;
	let defaultRowCnt = 20;

	let data_modal = {};
	let totalCnt_dev_modal;

	//====== 그리드 공통 부 START
	let ib_modal = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": defaultRowCnt,
				"AutoRowHeight": 1,
				"InfoRowConfig": "0",
				"Alternate": "0",
				"HeaderCheck": 1,
				"HeaderCheckMode": 1,
				"Height": "auto"
			},
			Def:{
				Row:{
					//AlternateColor: "FFFF00" // 하이라이트 색상을 노란색으로 설정
				}
			},
			//틀고정 좌측 컬럼 설정
			/*"LeftCols": [
				{"Header": "No","Name": "RN","Width": "90"}
			],*/
			"Cols": []
		},

		//시트객체 생성
		'create':function () {
			let options = this.init;
			options.Cols = sheetCols.current;

			if(sheetId.current == 'modal_2102_List'){
				options.Cfg.Height = '350px';
			}

			//sheetId
			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet_modal', // 생성할 시트의 id
				el: sheetId.current, // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				//data: this.data // 생성될 시트의 정적데이터
			});

			if(sheetId.current == 'modal_2102_List'){
				//@ts-ignore
				IBSheet.create({
					id: 'sheet_modal_right', // 생성할 시트의 id
					el: sheetId.current+'right', // 시트를 생성할 Dom 객체 및 id
					options: options, // 생성될 시트의 속성
					data: this.data // 생성될 시트의 정적데이터
				});
			}

			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},

		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				if(evtParam.sheet.id === 'sheet_modal_right'){
					// @ts-ignore
					//sheet_modal_right.loadSearchData(rightCorpList)
					// @ts-ignore
					sheet_modal_right.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
					// @ts-ignore
					//makePageIndex(sheet_modal_right.getPageIndex( sheet_modal_right.getFocusedPage()) + 1, 'right'); // 페이지 초기화
					//@ts-ignore
					// evtParam.sheet.getDataRows().map(e => {
					// 	e.Visible = 1;
					// 	e.sCheckBox = 0;
					// 	return e;
					// });

				}else{
					//초기 데이터 로딩
					initSheet_modal();
				}
			},

			//시트 더블클릭시 이벤트 처리
			onAfterClick:async function(evtParam){
				if(evtParam.kind != "Header"){
					//왼쪽 시트에서 수정 진입
					if(sheetId.current == 'modal_2102_List' && evtParam.sheet.id == 'sheet_modal' && (evtParam.col == 'CORP_NM' || evtParam.col == 'BIZ_NO') ){
						/*수정팝업 사업자 등록증 오류로 수정팝업 호출 주석처리*/
						/*const bizNo = evtParam.sheet.getValue(evtParam.sheet.getFocusedRow(), "BIZ_NO");
						setState({...state, selectBizNo2102: bizNo})
						await getCorp(bizNo);*/
					}else if(evtParam.col == "SELECT" ){
						const sheet = evtParam.sheet;
						const row = sheet.getFocusedRow();
						setState({...state, selectBiz: row, selectReaminDonAmt: row.REMAIN_DON_AMT, bizNm: row.BIZ_NM});
						await onClose('2139')
					}
				}
			},
			
			//시트가 렌더링된 후 발생되는 이벤트입니다. 발생시점은 아래와 같은 부분에서 발생합니다.
			onRenderFinish:function(evtParam){
				//렌더 종료 후 1페이지일때 보이는행 제외 visible 0 처리
				let sheet = evtParam.sheet;
				let page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				if(page === 1 && sheet.getShownRows().length != 0){
					sheet.getDataRows().filter(x => !sheet.getShownRows().includes(x)).map(e => {
						e.Visible = 0;
						return e;
					});
				}
				if(evtParam.sheet.id === 'sheet_modal') {
					if(evtParam.sheet.getDataRows().length > 0) {
						//1페이지의 보여지는 갯수 - 페이지보여지는 갯수
						let overCnt = evtParam.sheet.getPageByIndex(0).childNodes.length - state.showRowCnt;
						if(overCnt < 0) overCnt = 0;
						totalCnt = evtParam.sheet.getDataRows().length - overCnt;
						//@ts-ignore
						makePageIndex(page, 'left'); // 페이지 초기화
					}
				}
				evtParam.sheet.Header.sCheckBoxChecked = 0;
			},

			// 조회 후 로딩 전 발생 이벤트
			onBeforeDataLoad:function (evtParam) {
				let d = evtParam.data;
				let _data;

				let sliceData = [];
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					sliceData = d.slice(0, defaultRowCnt);
					_data = JSON.stringify(sliceData, null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}
			},

			onAfterGotoPage:function (evtParam) {
				let sheet = evtParam.sheet;
				let page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					let type = 'left';
					if(evtParam.sheet.id == 'sheet_modal_right') type = 'right';
					makePageIndex(page, type);
				}

				sheet.getDataRows().map(e => {
					e.Visible = 1;
					return e;
				})

				//@ts-ignore
				sheet.rerender(); //최종 수정된 내용을 화면에 반영한다.
			},

			onClick:function(evtParam) {
				if('Header' === evtParam.row.id) {
					if(0 === evtParam.row.sCheckBoxChecked) {	//체크
						//@ts-ignore
						evtParam.sheet.setAllCheck("sCheckBox", 0, 1);
						//@ts-ignore
						evtParam.sheet.getDataRows({currentPage:1}).map(m => {
							m.sCheckBox = 1;
							return m;
						});
					}else {	//언체크
						//@ts-ignore
						evtParam.sheet.getDataRows({currentPage:1}).map(m => {
							m.sCheckBox = 0;
							return m;
						});
					}
				}
			}
		},

		//엑셀 다운로드
		'exportData':function () {

		},
		//조회 데이터
		'data':[]
	}
	//====== 그리드 공통 부  END

	async function initSheet_modal() {
		let param = {};
		let url = '';

		if(sheetId.current == 'modal_2139_List'){
			param = {
				"BIZ_NO": '',
				"BIZ_CD" : state.bizCd
			};
			url = 'usr_2101_hando';
		}else if(sheetId.current == 'modal_2102_List'){
			param = {
				"BIZ_NO": state.bizNo2102,
				"CORP_NM": state.corpNm2102,
			};
			url = 'usr_2101_corp_list';
		}

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url: url,
			data: param
		})
		console.log(response);

		//전체데이터
		let result = response.REC;

		//전체ROW개수
		totalCnt = Object.keys(result).length;
		setState({...state, totalRowCnt: totalCnt})

		if(typeof result == 'undefined'){
			alert('data is not loaded!!!')
			return;
		}

		// @ts-ignore
		sheet_modal.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함

		// @ts-ignore
		makePageIndex(sheet_modal.getPageIndex( sheet_modal.getFocusedPage()) + 1, 'left'); // 페이지 초기화

		if(sheetId.current == 'modal_2102_List'){
			setTimeout(()=> {
				result.forEach((v) => {
					v['REAL_BIZ_NO'] = '' + (v.BIZ_NO).replace(/-/ig, '');
				});

				if(state.corpList.length != 0) {
					let dupList = result.filter( (item) => !state.corpList.some((i) => (i.BIZ_NO+'').replaceAll('-','') === item.BIZ_NO.replaceAll('-','')) );
					// @ts-ignore
					dupList = dupList.filter( (item) => !rightCorpList.some((i) => (i.BIZ_NO+'').replaceAll('-','') === item.BIZ_NO.replaceAll('-','')) );
					// @ts-ignore
					sheet_modal.loadSearchData(dupList);
					// @ts-ignore
					sheet_modal_right.loadSearchData(state.corpList);

				}else{
					// @ts-ignore
					sheet_modal.loadSearchData(result);
				}
			}, 300);

		}else{
			// @ts-ignore
			sheet_modal.loadSearchData(result);
		}
	};

	//====== 그리드 데이터 가지고 오기  END


	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number, type:string) {

		let pageNaviId = 'pageNavi';
		if(type == 'right') pageNaviId = 'pageNaviRight';
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			// @ts-ignore
			if (document.getElementById(pageNaviId).firstChild) {
				// @ts-ignore
				document.getElementById(pageNaviId).removeChild(document.getElementById(pageNaviId).firstChild);
			}

			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = totalCnt // 전체 조회 건수
			// @ts-ignore
			if(type == 'right') sr = 0 ;
			// @ts-ignore
			let page = state.showRowCnt; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				if(type == 'right') addEventHandler(li, 'click', pageMoveRight, 1);
				else addEventHandler(li, 'click', pageMove, 1);

				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				if(type == 'right') addEventHandler(li, 'click', pageMoveRight, tp - 1);
				else addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					if(type == 'right') addEventHandler(li, 'click', pageMoveRight, i);
					else addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				if(type == 'right') addEventHandler(li, 'click', pageMoveRight, tp + 1);
				else addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				if(type == 'right') addEventHandler(li, 'click', pageMoveRight, lastpage);
				else addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';
			// @ts-ignore
			document.getElementById(pageNaviId).appendChild(ul);
			if(sr == 0){
				// @ts-ignore
				document.getElementById(pageNaviId).appendChild('<div></div>');
			}
		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet_modal.goToPageByIndex(cPage);
	}

	//페이지 이동
	// @ts-ignore
	const pageMoveRight = function (cPage:number) {
		// @ts-ignore
		sheet_modal_right.goToPageByIndex(cPage);
	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

	/*
        //인풋 엔터체크
        const activeEnter = (e) => {
            if(e.key === "Enter") {
                doSearch('search');
            }
        }
    */

	const alertModalCustom = async (text:string) => {
		const value = await UIUtils.alert(<>
			<span className="fc-pri">*</span> {text}
		</>);
	}

	function addRow(type) {
		//@ts-ignore
		let allDupRows;
		//@ts-ignore
		const leftAllRows = sheet_modal.getDataRows({currentPage:1});
		//@ts-ignore
		const rightAllRows = sheet_modal_right.getDataRows();
		//@ts-ignore
		const leftChkRows = leftAllRows.filter(x => x.sCheckBox === 1);
		//@ts-ignore
		const rightChkRows = rightAllRows.filter(x => x.sCheckBox === 1);

		let isPass = false;
		if((type === 'right' && leftChkRows.length > 0) || (type === 'left' && rightChkRows.length > 0) || type === 'reset') isPass = true;

		if(isPass) {
			if('left' === type) {			//좌측으로 보냄(<-)
				//@ts-ignore
				allDupRows = rightChkRows.filter((item) => !leftAllRows.some((i) => i.REAL_BIZ_NO === item.REAL_BIZ_NO));
				//@ts-ignore
				sheet_modal.copyRows(allDupRows, sheet_modal.getFirstRow());
				//@ts-ignore
				sheet_modal_right.removeRows(rightChkRows);

			}else if('right' === type) {	//우측으로 보냄(->)
				//@ts-ignore
				allDupRows = leftChkRows.filter((item) => !rightAllRows.some((i) => i.REAL_BIZ_NO === item.REAL_BIZ_NO));
				//@ts-ignore
				sheet_modal_right.copyRows(allDupRows, sheet_modal_right.getFirstRow());
				//@ts-ignore
				sheet_modal.removeRows(leftChkRows);

			}else if('reset' === type) {	//선택초기화
				//@ts-ignore
				allDupRows = rightAllRows.filter((item) => !leftAllRows.some((i) => i.REAL_BIZ_NO === item.REAL_BIZ_NO));
				//@ts-ignore
				sheet_modal.copyRows(allDupRows, sheet_modal.getFirstRow());
				//@ts-ignore
				sheet_modal_right.removeRows(rightAllRows);
			}

		}else {
			alertModalCustom('대상을 선택해주세요.');
			return;
		}

		allDupRows = null;
		//@ts-ignore
		sheet_modal.rerender(); //최종 수정된 내용을 화면에 반영한다.
		//@ts-ignore
		sheet_modal_right.rerender(); //최종 수정된 내용을 화면에 반영한다.
		//@ts-ignore
		sheet_modal.getDataRows().map(e => {
			e.Visible = 1;
			e.sCheckBox = 0;
			return e;
		});
		//@ts-ignore
		sheet_modal_right.getDataRows().map(e => {
			e.Visible = 1;
			e.sCheckBox = 0;
			return e;
		});
		//@ts-ignore
		sheet_modal.selectAllRows(0);
		//@ts-ignore
		sheet_modal_right.selectAllRows(0);
	}

	function savePerfCorpList() {
		//@ts-ignore
		if(sheet_modal_right.getDataRows().length == 0){
			alertModalCustom('반영할 수행기관이 없습니다.');
			return;
		}

		//@ts-ignore
		setRightCorpList(sheet_modal_right.getDataRows());

		//@ts-ignore
		const selectCorpList = sheet_modal_right.getDataRows().map(function(v){
			return v.CORP_NM
		}).join(',');

		//@ts-ignore
		setState({...state, selectCorpList: selectCorpList, corpList : sheet_modal_right.getDataRows()})

		onClose('2102');
	}

	function chkValid2103(){
		let chk2103 = "";
		if(state.corpNm2103 == ''){
			return "[기업명]";
		}
		if(state.bizNo2103 == ''){
			return "[사업자등록번호]";
		}
		if(state.ceoNm2103 == ''){
			return "[대표자명]";
		}
		if(state.estaFormCd2103 == ''){
			return "[설립형태]";
		}
		if(state.corpSizeCd2103 == ''){
			return "[기업규모]";
		}
		if(state.induCd2103 == ''){
			return "[업종]";
		}
		if(state.personNm2103 == ''){
			return "[담당자명]";
		}

		// 썸네일 파일업로드 영역에 업로드 된 파일 갯수 체크
        console.log("uploadIdThumb : " + uploadId2103);
        const ThumbFileListInfo = window["RAONKUPLOAD"].GetListInfo("array", uploadId2103);
        console.log("fileListInfo", ThumbFileListInfo);
        console.log(Object.keys(ThumbFileListInfo).length);
        console.log("fileListInfo.mergeFIle", ThumbFileListInfo?.mergeFile);

        if(ThumbFileListInfo?.mergeFile == null){
            return "[사업자 등록증]";
        }

		return chk2103;
	}

	function chkValid2104(){
		let chk2104 = "";
		if(state.corpNm2104 == ''){
			return "[기업명]";
		}
		if(state.bizNo2104 == ''){
			return "[사업자등록번호]";
		}
		if(state.ceoNm2104 == ''){
			return "[대표자명]";
		}
		if(state.estaFormCd2104 == ''){
			return "[설립형태]";
		}
		if(state.corpSizeCd2104 == ''){
			return "[기업규모]";
		}
		if(state.induCd2104 == ''){
			return "[업종]";
		}
		if(state.personNm2104 == ''){
			return "[담당자명]";
		}

		// 썸네일 파일업로드 영역에 업로드 된 파일 갯수 체크
       // console.log("uploadIdThumb : " + uploadId2104);
        const ThumbFileListInfo = window["RAONKUPLOAD"].GetListInfo("array", uploadId2104);
      //  console.log("fileListInfo", ThumbFileListInfo);
     //   console.log(Object.keys(ThumbFileListInfo).length);
     //   console.log("fileListInfo.mergeFIle", ThumbFileListInfo?.mergeFile);

        if(ThumbFileListInfo?.mergeFile == null){
            return "[사업자 등록증]";
        }

		return chk2104;
	}

	//수행기업 저장
	async function saveCorp(chk){
		if(!CommonUtil.bizNoCheck(state.bizNo2103)) return;
		let valid2103 = chkValid2103();
		if(valid2103 == "") {
			if (chk) {
				setUploadComp2103(false);

				let estaDate = DateUtil.toDateFormat(state.estaDate2103, "YYYY-MM-DD");
				let param = {
					"CORP_NM": state.corpNm2103,
					"BIZ_NO": (state.bizNo2103).replace(/-/ig, ''),
					"CEO_NM": state.ceoNm2103,
					"ESTA_DATE": estaDate,
					"ESTA_FORM_CD": state.estaFormCd2103,
					"CORP_SIZE_CD": state.corpSizeCd2103,
					"INDU_CD": state.induCd2103,
					"MANG_USER_NM": state.personNm2103,
					"EMAIL_ADRES": state.emailAdres2103,
					"OFC_TEL_NO": state.ofcTelNo2103,
					"HP_NO": state.hpNo2103,
					"FILE_ID": '',
					FILE_INFO_LIST: fileInfoList2103
				};

				//파라미터 전송
				const response: any = await CommonUtil.execute({
					url: 'perfCorpAndPerSonInsert',
					data: param
				}).then((response: any) => {
					if(response){
						UIUtils.alert('저장되었습니다.').then(()=>{
							onClose('2103');
							initSheet_modal();
						});						
					}
				}).catch(err => {
					CommonUtil.showAxiosError(err);
					return;
				});

			} else {
				if (await UIUtils.confirm('저장 하시겠습니까?')) {
					onFileUpload2103();
				}
			}
		} else{
			UIUtils.alert(<><div className='ta-center'>필수 입력이 완료되지 않았습니다. <br/>다시 확인해 주세요.<br/>{valid2103}</div></>).then();
		}
	}

	//수행기업 상세정보 2104
	async function getCorp(bizNo){
		let param = {
			"BIZ_NO": bizNo.replace(/-/ig, ''),
		};

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:'perfCorpAndPerSonSelect',
			data: param
		})
		let result = response;

		//사업자 등록증이 있을경우
		if(result.BIZLIC_INFO != null && result.BIZLIC_INFO.length > 0){
            let bizFileInfo = result.BIZLIC_INFO;
			bizLicFileValue.setTbComFileMapngDetailList([]);
			const tempFileValue = new TbComFile();

			//파일등록 정보
			bizFileInfo?.forEach((bizFileInfo, index) => {
				const bizLicDetail = new TbComFileMapngDetail();
				bizLicDetail.setDwldId(bizFileInfo.DWLD_ID);
				bizLicDetail.setFileDetailId(bizFileInfo.FILE_DETAIL_ID);
				bizLicDetail.setFilePolicy(bizFileInfo.FILE_POLICY);
				bizLicDetail.setFileRpstr(bizFileInfo.FILE_RPSTR);
				bizLicDetail.setStrePath(bizFileInfo.STRE_PATH);
				bizLicDetail.setStreFileNm(bizFileInfo.STRE_FILE_NM);
				bizLicDetail.setOrginlFileNm(bizFileInfo.ORGINL_FILE_NM);
				bizLicDetail.setFileExtsn(bizFileInfo.FILE_EXTSN);
				bizLicDetail.setFileSize(bizFileInfo.FILE_SIZE);
				bizLicDetail.setRegistPsnNm(bizFileInfo.REGIST_PSN_NM);
				bizLicDetail.setRegistDt(bizFileInfo.REGIST_DT);
				//bizLicFileValue.putTbComFileMapngDetailList(bizLicDetail);
				tempFileValue.putTbComFileMapngDetailList(bizLicDetail);
			})
			setBizLicFileValue(tempFileValue);
		}

		setState({...state,
			estaDate2104: new Date(Number(result.ESTA_DATE)),
			ceoNm2104: result.CEO_NM,
			corpNm2104: result.CORP_NM,
			corpSizeCd2104: result.CORP_SIZE_CD,
			emailAdres2104: result.EMAIL_ADRES,
			estaFormCd2104: result.ESTA_FORM_CD,
			fileId2104: result.FILE_ID,
			hpNo2104: result.HP_NO,
			induCd2104: result.INDU_CD,
			personNm2104: result.MANG_USER_NM,
			ofcTelNo2104: result.OFC_TEL_NO,
			donBizNo2104: result.DON_BIZ_NO,
			bizNo2104: result.BIZ_NO,
			history2104: result.REC
		})
		setModal2104IsOpen(true);
	}

	//수행기업 수정 2104
	async function updateCorp(chk){
		if(!CommonUtil.bizNoCheck(state.bizNo2103)) return;
		let valid2104 = chkValid2104();
		if(valid2104 == "") {
			if(chk){
				setUploadComp2104(false);

				let estaDate = DateUtil.toDateFormat(state.estaDate2104, "YYYY-MM-DD");
				let param = {
					"CORP_NM": state.corpNm2104,
					"BIZ_NO": (state.bizNo2104).replace(/-/ig, ''),
					"DON_BIZ_NO": state.donBizNo2104,
					"CEO_NM": state.ceoNm2104,
					"ESTA_DATE": estaDate,
					"ESTA_FORM_CD": state.estaFormCd2104,
					"CORP_SIZE_CD": state.corpSizeCd2104,
					"INDU_CD": state.induCd2104,
					"MANG_USER_NM": state.personNm2104,
					"EMAIL_ADRES": state.emailAdres2104,
					"OFC_TEL_NO": state.ofcTelNo2104,
					"HP_NO": state.hpNo2104,
					"FILE_ID": state.fileId2104,
					"FILE_INFO_LIST": fileInfoList2104
				};

				//파라미터 전송
				const response:any = await CommonUtil.execute({
					url:'perfCorpAndPerSonUpdate',
					data: param
				}).then((response: any) => {
					if(response){
						UIUtils.alert('저장되었습니다.').then(()=>{
							onClose('2104');
							initSheet_modal();
						});
					}
				}).catch(err => {
					CommonUtil.showAxiosError(err);
					resetData('2104');
					initSheet_modal();
					return;
				});

			}else{
				if (await UIUtils.confirm('저장 하시겠습니까?')) {
					await onFileUpload2104();
				}
			}
		}else{
			UIUtils.alert(<><div className='ta-center'>필수 입력이 완료되지 않았습니다. <br/>다시 확인해 주세요.<br/>{valid2104}</div></>).then();
		}
	}

	async function chkValid(){
		var cnt = 0;
		
		
		if(state.selectReaminDonAmt == 0){
			return {'TYPE':'valid','NAME':'과제신청 가능금액'};
		}
		
		if(state.tskNm == ''){
			return {'TYPE':'valid','NAME':'과제명'};
		}
		
		if(state.tskStDate == null || state.tskEnDate == null){
			return {'TYPE':'valid','NAME':'과제기간'};
		}
		
		if(state.tskStDate > state.tskEnDate){
			return {'TYPE':'valid','NAME':'과제기간'};
		}
		
		if(state.funPurUseCd == ''){
			return {'TYPE':'valid','NAME':'기금사용용도'};
		}
		
		if(state.bizKindCd1 == ''){
			return {'TYPE':'valid','NAME':'과제분류(대분류)'};
		}
		
		if(state.bizKindCd2 == ''){
			return {'TYPE':'valid','NAME':'과제분류(소분류)'};
		}
		
		if(state.suppCont == ''){
			return {'TYPE':'valid','NAME':'과제개요'};
		}
		
		if(state.suppCorpCnt == 0){
			return {'TYPE':'valid','NAME':'중소기업 지원수'};
		}
		
		if(state.open2102 == 'open'){
			
			if(bizFileValue.tbComFileMapngDetailList.length == 0 && fileInfoListPop.filter(a => a.FILE_GB == 'BIZ').length == 0 || bizFileNm == ""){
				return {'TYPE':'valid','NAME':'수행기관 사업자 등록증'};
			}

			if(rightCorpList.length == 0 && state.selectCorpList == ''){
				return {'TYPE':'valid','NAME':'수행기관'};
			}
			
		}
		
		/*if(state.exeEffDesc == ''){
			return 'valid';
		}*/
		
		state.amtList?.forEach((item, index) => {
			if(item.SUPP_AMT == 0 || item.SUPP_AMT == ''){
				cnt++;
			};
		});
		
		if(cnt > 0){
			return {'TYPE':'valid','NAME':'지원 항목 별 지원금'};
		}
		if(state.amtList.length == 1 && state.amtList[0].SUPP_AMT == 0){
			return {'TYPE':'valid','NAME':'지원 항목 별 지원금'};
		}


		if(state.elecApprYn == 'N'){
			if(reqFileValue.tbComFileMapngDetailList.length == 0 && fileInfoListPop.filter(a => a.FILE_GB == 'REQ').length == 0 || reqFileNm == ""){
				return {'TYPE':'valid','NAME':'과제 신청서'};
			}
		}


		if(planFileValue.tbComFileMapngDetailList.length == 0 && fileInfoListPop.filter(a => a.FILE_GB == 'PLAN').length == 0 || planFileNm == "" ){
			return {'TYPE':'valid','NAME':'과제 계획서'};
		}
		
        if(state.personNm == ''){
            return {'TYPE':'valid','NAME':'담당자'};
        }


		//변경심사 상태인경우
		if(state.tskReqStsCd == 'E'){
			let eChk = false;

			//변경이력 선택시
			if(state.isUA && state.judgeCmtUA == ''){
				eChk = true;
			}
			if(state.isUD && state.judgeCmtUD == ''){
				eChk = true;
			}
			if(state.isUE && state.judgeCmtUE == ''){
				eChk = true;
			}

			if(eChk){
				UIUtils.alert('변경심사를 선택한 경우 변경이력을 필수로 입력해 주세요.').then();
				return
			}
			if(!state.isUA && !state.isUD && !state.isUE){
				UIUtils.alert('변경심사를 선택한 경우 변경이력을 필수로 입력해 주세요.').then();
				return
			}

			//금액이 변경되었는데 체크를 안한경우
			if(!state.isUA && Number(state.oldTskInfo.SUPP_AMT) != state.totalAmt){
				UIUtils.alert('금액이 변경된 경우 변경이력을 필수로 입력해 주세요.').then();
				return
			}

			let oldSt = DateUtil.toDateFormat(new Date(Number(state.oldTskInfo.TSK_ST_DATE)), "YYYY-MM-DD");
			let oldEn = DateUtil.toDateFormat(new Date(Number(state.oldTskInfo.TSK_EN_DATE)), "YYYY-MM-DD");
			let sDt = DateUtil.toDateFormat(state.tskStDate, "YYYY-MM-DD");
			let eDt = DateUtil.toDateFormat(state.tskEnDate, "YYYY-MM-DD");
			//기간이 변경되었는데 체크를 안한경우
			if(!state.isUD && (oldSt != sDt || oldEn != eDt)){
				UIUtils.alert('기간이 변경된 경우 변경이력을 필수로 입력해 주세요.').then();
				return
			}
		}

		let url = 'usr_2101_hando_chk';
		let param = {
			"BIZ_CD": state.tskBizCd
			,"BIZ_NO": state.tskBizNo
		};

		//파라미터 전송
		const response:any = await CommonUtil.execute({
			url:url,
			data: param
		})

		if(state.totalAmt <= Number(response.REMAIN_DON_AMT) + Number(state.oldTskInfo.SUPP_AMT)){
			return 'none'
		}else{
			return 'amt'
		}
	}

	async function saveTsk(chkUpdate){
		if(chkUpdate){
			setState({...state, uploadComp: false})
			let sDt = DateUtil.toDateFormat(state.tskStDate, "YYYY-MM-DD");
			let eDt = DateUtil.toDateFormat(state.tskEnDate, "YYYY-MM-DD");
			let bizNoes = '';
			if(rightCorpList.length != 0){
				bizNoes = rightCorpList.map(function(value){
					// @ts-ignore
					return (value.BIZ_NO+"").replaceAll('-', '')
				}).join(',');

			}else{
				if(state.open2102 != ''){
					bizNoes = state.corpList.map(function(value){
						// @ts-ignore
						return (value.BIZ_NO+"").replaceAll('-', '')
					}).join(',');
				}
			}

			if(state.tskBizCd.indexOf('O') != -1){
				bizNoes = '1078210445'; //대중소기업농어업협력재단 사업자번호 //운영비로 들어왔을때 고정
			}

			// @ts-ignore
			let questionText = Object.keys(state.qList).map(function(value) { return state.qList[value] }).join('^||^');
			let param = {
				TSK_REQ_NO : receivedData.TSK_REQ_NO,
				TSK_REQ_MODI_SEQ : receivedData.TSK_REQ_MODI_SEQ,
				"FUN_PUR_USE_CD": state.funPurUseCd,
				"FUN_PUR_USE_NO": state.funPurUseNo,
				"BIZ_KIND_CD_1": state.bizKindCd1,
				"BIZ_KIND_CD_2": state.bizKindCd2,
				"TSK_NM": state.tskNm,
				"SUPP_CONT": state.suppCont,
				"EXE_EFF_DESC": state.exeEffDesc,
				"BIZ_NOES": bizNoes,
				"TOT_AMT": state.totalAmt,
				"SUPP_AMT": state.totalAmt,
				"TSK_ST_DATE": sDt,
				"TSK_EN_DATE": eDt,
				"ITEM_LIST": state.amtList,
				"QUESTION" : '',
				"QUE_LIST" : state.queList,
				"PERSON_NM" : state.personNm,
				"PERSON_ID" : state.personId,
				"POSI_NM" : state.posiNm,
				"DEPT_NM" : state.deptNm,
				"EMAIL_ADRES" : state.emailAdres,
				"OFC_TEL_NO" : state.ofcTelNo,
				"SUPP_CORP_CNT" : state.suppCorpCnt,
				"OTHER_SUPP_CORP_CNT" : state.otherSuppCorpCnt,
				"IS_UA" : !state.isUA ? "N" : "Y",
				"IS_UD" : !state.isUD ? "N" : "Y",
				"IS_UE" : !state.isUE ? "N" : "Y",
				"JUDGE_CMT_UA" : state.judgeCmtUA,
				"JUDGE_CMT_UD" : state.judgeCmtUD,
				"JUDGE_CMT_UE" : state.judgeCmtUE,
				"UA_OLD" : state.oldTskInfo.TOT_AMT,
				"UD_OLD" : dateToStr(state.oldTskInfo.TSK_ST_DATE) + '~' + dateToStr(state.oldTskInfo.TSK_EN_DATE),
				"UD_NEW" : dateToStr(state.tskStDate) + '~' + dateToStr(state.tskEnDate),
				"BIZ_NO" : state.tskBizNo,
				"BIZ_CD" : state.tskBizCd,
				"FILE_ID" : state.fileId,
				FILE_INFO_LIST:fileInfoListPop.concat(fileInfoList),
				"FORE_TSK_YN" : state.foreTskYn,
				"ADD_TOT_AMT": state.addTotalAmt,
				"ADD_ITEM_LIST": state.addAmtList,
			};

			//파라미터 전송
			const response:any = await CommonUtil.execute({
				url:'usr_2108_update',
				data: param
			})
			console.log(response);
			UIUtils.alert('정상처리되었습니다.').then(()=>{
				// 다른 페이지로 이동하면서 데이터 전달
				history.push({
					pathname: './usr_2105',
					state: { data: JSON.parse(receivedData.vAll_PARAM) }
				});
			}).catch(err => {
				CommonUtil.showAxiosError(err);
				return;
			});

		}else{
			if(Number(state.selectReaminDonAmt) + Number(state.oldTskInfo.SUPP_AMT) < state.totalAmt){
				let text = '지원 항목별 합계금액을 과제신청금액보다 같거나 작게 입력해 주세요';
				await alertModalCustom(text);
				return;
			}

			let chk = await chkValid();
			let ch = (typeof(chk) == 'object') ? chk.TYPE:chk;
			let nm = (typeof(chk) == 'object') ? '['+chk.NAME+']':"";
			
			if(ch == 'valid'){
				await UIUtils.alert(<><div className='ta-center'>필수 입력이 완료되지 않았습니다. <br/>다시 확인해 주세요.<br/>{nm}</div></>);
				return
			}
			if(ch == 'amt'){
				await UIUtils.alert('과제신청 가능금액이 변경되어 잔액이 부족합니다.');
				return
			}
			if(ch == 'none'){
				if(await UIUtils.confirm('저장하시겠습니까?')){
					if(uploadId == ''){
						setUploadComp(true);
					}else{
						onFileUpload();
					}
				}
			}
		}
	}

	function initCall(){
		const result = receivedData;
		console.log(result);

		otherFiles.setTbComFileMapngDetailList([]);
		reqFileValue.setTbComFileMapngDetailList([]);
		planFileValue.setTbComFileMapngDetailList([]);
		bizFileValue.setTbComFileMapngDetailList([]);

		let fileList = result.FILE_INFO;
		for(let i = 0; i < fileList.length; i++){
			if(fileList[i].FILE_GB == 'REQ'){
				let reqFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(reqFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(reqFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(reqFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(reqFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(reqFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(reqFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(reqFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(reqFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(reqFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(reqFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(reqFileInfo.REGIST_DT);
				reqFileValue.putTbComFileMapngDetailList(fileDetail);
				setReqFileNm(reqFileInfo.ORGINL_FILE_NM);

			}else if(fileList[i].FILE_GB == 'PLAN'){
				let planFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(planFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(planFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(planFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(planFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(planFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(planFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(planFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(planFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(planFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(planFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(planFileInfo.REGIST_DT);
				planFileValue.putTbComFileMapngDetailList(fileDetail);

				setPlanFileNm(planFileInfo.ORGINL_FILE_NM);

			}else if(fileList[i].FILE_GB == 'BIZ'){
				let bizFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(bizFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(bizFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(bizFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(bizFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(bizFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(bizFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(bizFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(bizFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(bizFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(bizFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(bizFileInfo.REGIST_DT);
				bizFileValue.putTbComFileMapngDetailList(fileDetail);

				setBizFileNm(bizFileInfo.ORGINL_FILE_NM);

			}else{
				let otherFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(otherFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(otherFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(otherFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(otherFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(otherFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(otherFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(otherFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(otherFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(otherFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(otherFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(otherFileInfo.REGIST_DT);
				otherFiles.putTbComFileMapngDetailList(fileDetail);
			}
		}

		setLoadFinish(true);
	}

	//기부금 사용용도에 따른 과제 대분류 가져오기
	async function changeFunPurUseNo(code:string){
		let value = CommonUtil.suppSizeMappingVal(code);
		if(StringUtil.isEmpty(value))
			return [];

		let suppSizeA = codeDataStore.get("common.suppSizeA," + value);
		if(suppSizeA == null || suppSizeA.length === 0) {
			await codeDataStore.read("common.suppSizeA," + value)
			suppSizeA = codeDataStore.get("common.suppSizeA," + value);
		}
		console.log('funPurUseNo : ' + value)
		return suppSizeA;
	}

	//과제 대분류로 과제 소분류 가지고 오기 //처음 세팅용도
	async function changeSuppSizeA(funPurUseNo: string, code: string){
		if(StringUtil.isEmpty(code))
			return [];

		let suppSizeB = codeDataStore.get("common.suppSizeB," + funPurUseNo + "," + code);
		if(suppSizeB == null || suppSizeB.length === 0) {
			await codeDataStore.read("common.suppSizeB," + funPurUseNo + "," + code);
			suppSizeB = codeDataStore.get("common.suppSizeB," + funPurUseNo + "," + code);
			console.log('after / funPurUseNo : ' + funPurUseNo + ' / code : ' + code + ' / ' + JSON.stringify(suppSizeB))
		}
		return suppSizeB;
	}

	//과제 대분류로 과제 소분류 가지고 오기 //셀렉트용
	async function changeSuppSizeA_1(code:string){
		console.log('대분류 셀렉트')
		if(loadFinish){
			// setLoadFinish(false);
			await codeDataStore.read("common.suppSizeB," + state.funPurUseNo + "," + code);
			console.log("common.suppSizeB1111", codeDataStore.get("common.suppSizeB," + state.funPurUseNo + "," + code))
			setState({...state, bizKindCd1: code, bizKindCd1List: codeDataStore.get("common.suppSizeB," + state.funPurUseNo + "," + code)})
			// setLoadFinish(true);
		}
	}

	/**
   * 파일업로드 팝업
   */
	const reqModal = (type) => {
		// REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
		let title = '과제신청서';
		if(type == 'PLAN') title = '과제 계획서';
		else if(type == 'BIZ') title = '수행기관 사업자 등록증';

		UIUtils.openFileUploadPopup({
			title: title,
			buttonTitle: "등록",
			attrs: {
				MaxTotalFileCount: "1",
				ExtensionAllowOrLimit: "1",
			},
			valueChanged: async data => {
				console.log("fileId uploadId : "+ uploadId);
				// @ts-ignore
				if(data != undefined && data.tbComFileMapngDetailList.length != 0){
					const dataArray = window["RAONKUPLOAD"].GetListInfo('array', uploadId);
					const arrayNew = dataArray.newFile;
					const arrayDel = dataArray.deleteFile;
					console.log("arrayNew", JSON.stringify(arrayNew));

					let fileInfos : {
						FILE_DETAIL_ID:string | undefined;
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					}[] = [];

					let fileInfo : {
						FILE_DETAIL_ID:string | undefined;
						ORGINL_FILE_NM:string | undefined;
						STRE_FILE_NM:string | undefined;
						FILE_SIZE:number | undefined;
						STRE_PATH:string | undefined;
						FILE_EXTSN:string | undefined;
						FILE_GB:string | undefined;
						FILE_STATUS:string | undefined;
					};

					// @ts-ignore
					let item = data.tbComFileMapngDetailList[0];

					// @ts-ignore
					let uniqKey = item.uniqKey;
					// @ts-ignore
					let orginlFileNm = item.orginlFileNm;
					// @ts-ignore
					let streFileNm = item.streFileNm;
					// @ts-ignore
					let fileSize = item.fileSize;
					// @ts-ignore
					let strePath = item.strePath;
					// @ts-ignore
					let fileExtsn = item.fileExtsn;

					//파일등록 정보
					fileInfo = {
						FILE_DETAIL_ID:uniqKey,
						ORGINL_FILE_NM:orginlFileNm,
						STRE_FILE_NM:streFileNm,
						FILE_SIZE:fileSize,
						STRE_PATH: strePath,
						FILE_EXTSN:fileExtsn,
						FILE_GB:type,
						FILE_STATUS:"ADD"
					}
					if(type == 'REQ'){
						// @ts-ignore
						setReqFileNm(orginlFileNm)
					}else if(type == 'PLAN'){
						// @ts-ignore
						setPlanFileNm(orginlFileNm)
					}else if(type == 'BIZ'){
						// @ts-ignore
						setBizFileNm(orginlFileNm)
					}

					fileInfos.push(fileInfo);
					console.log(fileInfoListPop);
					if(fileInfoListPop.filter(a => a.FILE_GB == type).length == 0){
						setFileInfoListPop(fileInfoListPop.concat(fileInfos));
					}else{
						let newList = [...fileInfoListPop];
						newList = newList.filter(a => a.FILE_GB != type)
						setFileInfoListPop(newList.concat(fileInfos));
					}
				}
			}
		})
	}

	async function fileDelete(type){
		// @ts-ignore
		let item;
		if(type == 'REQ' && reqFileValue.tbComFileMapngDetailList.length != 0){
			item = reqFileValue.tbComFileMapngDetailList[0];
		}
		if(type == 'PLAN' && planFileValue.tbComFileMapngDetailList.length != 0){
			item = planFileValue.tbComFileMapngDetailList[0];
		}
		if(type == 'BIZ' && bizFileValue.tbComFileMapngDetailList.length != 0){
			item = bizFileValue.tbComFileMapngDetailList[0];
		}


		if(item == undefined && fileInfoListPop.filter(a => a.FILE_GB == type).length != 0){
			let newList = [...fileInfoListPop];
			newList = newList.filter(a => a.FILE_GB != type)
			setFileInfoListPop(newList);
			UIUtils.alert('정상 처리 되었습니다 저장시 파일이 삭제 됩니다.').then();
			if(type == 'REQ'){
				// @ts-ignore
				setReqFileNm('')
			}else if(type == 'PLAN'){
				// @ts-ignore
				setPlanFileNm('')
			}else if(type == 'BIZ'){
				// @ts-ignore
				setBizFileNm('')
			}
			return;
		}else if(item == undefined){
			UIUtils.alert('삭제 할 파일이 없습니다.').then();
			return;
		}

		if(await UIUtils.confirm('삭제하시겠습니까?')){

			if(type == 'REQ') setReqFileNm('')
			if(type == 'PLAN') setPlanFileNm('')
			if(type == 'BIZ') setBizFileNm('')

			let fileInfos : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			}[] = [];

			let fileInfo : {
				FILE_DETAIL_ID:string | undefined;
				ORGINL_FILE_NM:string | undefined;
				STRE_FILE_NM:string | undefined;
				FILE_SIZE:number | undefined;
				STRE_PATH:string | undefined;
				FILE_EXTSN:string | undefined;
				FILE_GB:string | undefined;
				FILE_STATUS:string | undefined;
			};

			// @ts-ignore
			let uniqKey = item.fileDetailId;
			// @ts-ignore
			let orginlFileNm = item.orginlFileNm;
			// @ts-ignore
			let streFileNm = item.streFileNm;
			// @ts-ignore
			let fileSize = item.fileSize;
			// @ts-ignore
			let strePath = item.strePath;
			// @ts-ignore
			let fileExtsn = item.fileExtsn;

			//파일등록 정보
			fileInfo = {
				FILE_DETAIL_ID:uniqKey,
				ORGINL_FILE_NM:orginlFileNm,
				STRE_FILE_NM:streFileNm,
				FILE_SIZE:fileSize,
				STRE_PATH: strePath,
				FILE_EXTSN:fileExtsn,
				FILE_GB:type,
				FILE_STATUS:"DEL"
			}

			fileInfos.push(fileInfo);
			let newList = [...fileInfoListPop];
			setFileInfoListPop(newList.concat(fileInfos));
			UIUtils.alert('정상 처리 되었습니다 저장시 파일이 삭제 됩니다.').then();
		}
	}

	function moveBack(){
		let vTSK_REQ_NO = state.TSK_REQ_NO.replaceAll('-', '');
		let vTSK_REQ_MODI_SEQ = state.TSK_REQ_MODI_SEQ;

		let dataToSend = {vTSK_REQ_NO,vTSK_REQ_MODI_SEQ, vAll_PARAM:receivedData.vAll_PARAM};

		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './usr_2107',
			state: { data: dataToSend }
		});
	}

	function moveBack2105(){
		history.push({
			pathname: './usr_2105',
			state: { data: JSON.parse(receivedData.vAll_PARAM) }
		});

	}

	const modalusr2139 = useToggleState({});

	const downloadButtonClickHandler = (kind:string) => {
		/*if(kind == 'REQ') CommonUtil.downloadTemplateFile("ProjectApplicationForm.hwp", "과제 신청서(양식).hwp");*/
		if(kind == 'REQ') CommonUtil.downloadTemplateFile("ProjectApplicationFormNew.hwp", "양식_과제승인신청서.hwp");
	}

	const manageSelect = (e) => {
		let selectManage = state.REC.filter(a => a.PERSON_ID == e.target.value);
		if (selectManage.length != 0) {
			let info = selectManage[0];
			setState({
				...state,
				personId: info.PERSON_ID,
				corpNm: info.CORP_NM,
				bizNo: info.BIZ_NO,
				corpRegNo: info.CORP_REG_NO,
				personNm: info.PERSON_NM,
				posiNm: info.POSI_NM,
				deptNm: info.DEPT_NM,
				emailAdres: info.EMAIL_ADRES,
				ofcTelNo: info.OFC_TEL_NO,
			})
		}
	}

	// init
	React.useEffect( () => {
		initCall();
		codeDataStore.read("[SCS]", "[FPUC]", "cfms.portalBizCdList", "[INC]", "[EFC]").then(() => {
			console.log("[INC]", codeDataStore.get("[INC]"))
			console.log("[EFC]", codeDataStore.get("[EFC]"))
			console.log("ccfms.portalBizCdList", codeDataStore.get("cfms.portalBizCdList"))
		});

		return () => {
		}
	},[])

	// init
	React.useEffect( () => {
		console.log("state", state);
	},[state])

	if(!loadFinish)
		return (
			<PageLoading/>
		);
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={2} lnbIdx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">과제 내용 수정</h1>
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<h3 className="section-title">과제 신청 정보</h3>
							<p className="tx-msg"><span className="fc-pri">*</span>&nbsp;필수 입력</p>
						</div>
						<div className="fo fo-col2">
							<div className="inner">
								<div className="fo-item req">
									<div className="fo-key">출연사업</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<UIInput className={'tf tf-md hz-item hz-fg'} value={state.bizNm} placeholder={''} readOnly={true}/>
											{/*<Button color='pri-o2' size="md" onClick={() => setModal2139IsOpen(true)}>출연사업선택</Button>*/}
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<div className="fo-key">과제신청 가능금액(원)</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<div className="tf-unit hz-item hz-fg">
												<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(state.reaminDonAmt)) || "0"} placeholder={''} readOnly={true}/>
												<span className="u">원</span>
											</div>
										</div>
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<div className="fo-key">
										<span className="req">과제명</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip1">도움말 </button>
										<Tooltip
											id="tooltip1"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">출연기업의 지원과제계회 제목을 작성(연도 구분 있을 시 연도 표시)</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.tskNm} valueChanged={(value) => setState({...state, tskNm: value})} placeholder={'과제명을 입력하세요'}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">과제신청번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.TSK_REQ_NO} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">진행상태</p>
									<div className="fo-value">
										{state.tskReqStsNm == '신청' ? (<label className="badge badge-22 blue">신청</label>) : ''}
										{state.tskReqStsNm == '접수완료' ? ( <label className="badge badge-22 green">접수완료</label>) : ''}
										{state.tskReqStsNm == '수정요청' ? ( <label className="badge badge-22 yellow">수정요청</label>) : ''}
										{state.tskReqStsNm == '반려' ? (<label className="badge badge-22 red">반려</label>) : ''}
										{state.tskReqStsNm == '변경심사' ? ( <label className="badge badge-22 purple">변경심사</label>) : ''}
										{state.tskReqStsNm == '심사완료' ? ( <label className="badge badge-22 gray">심사완료</label>) : ''}
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">
										<span className="req">과제기간</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip2">도움말</button>
										<Tooltip
											id="tooltip2"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">
												<h6 className="tooltip-title">과제 운영기간(최대 1년), 사업기갑 변경시 과제변경 신청 필수</h6>
												<span className="fc-pri">(사업기간 내 사업 운영 및 비용 집행)</span> <br/>
												모든 제출 증빙자료의 발행일자가 고제 기간 내에 포함될 수 있도록 설정 바랍니다.<br/>ex) 견적서, 세금계선서, 이체확인증 등<br/>
												<p className="mt5">※ 해당연도 지급 요청 마감은 매년 11월 30일 18:00까지이며 이후 당해연도 내 추가 지급신청 불가.</p>
											</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5 w100p">
											<UIDatePicker className="hz-item" value={state.tskStDate} valueChanged={(value) => setState({...state, tskStDate:value})}/>
											<span className="hz-item">~</span>
											<UIDatePicker className="hz-item" value={state.tskEnDate} valueChanged={(value) => setState({...state, tskEnDate: value})}/>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<div className="fo-key">
										<span className="req">기금사용용도</span>
										<button type="button" className="button-tooltip"
												data-tooltip-id="tooltip3">도움말
										</button>
										<Tooltip
											id="tooltip3"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">‘[참고] 상생협력기금 사용용도 분류표＇를 참조하여 해당하는 번호를 기입</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											{/*<UISelect
											codeData={fpucList}
											value={funPurUseCd}
											valueChanged={(value) => setFunPurUseCd(String(value))}
											firstName={"sel"}
										/>*/}
											<UISelect
												codeData={codeDataStore.get("[FPUC]")}
												value={state.funPurUseCd}
												valueChanged={(value) => {
													const code = String(value);
													(async () => {
														const bizKindCd1List = await changeFunPurUseNo(code);
														let codeValue = CommonUtil.suppSizeMappingVal(code);
														setState({
															...state,
															funPurUseNo:codeValue,
															funPurUseCd: code,
															bizKindCd1List: bizKindCd1List
														});
													})();
												}}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">과제분류(대분류)</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											{/*<UISelect
											codeData={bizKindCd1List}
											value={bizKindCd1}
											valueChanged={
												(value) => {
													setBizKindCd1(String(value));
													// codeDataStore.read("common.suppSizeB," + funPurUseNo + "," + value).then(() => {
													// 	console.log("common.suppSizeB", codeDataStore.get("common.suppSizeB," + funPurUseNo + "," + value))
													// });
												}
											}
											firstName={"sel"}
										/>*/}
											<UISelect
												codeData={state.bizKindCd1List}
												value={state.bizKindCd1}
												valueChanged={
													(value) => {
														if(loadFinish) {
															const code = String(value);
															(async () => {
																const bizKindCd2List = await changeSuppSizeA(state.funPurUseNo, code);
																// const bizKindCd2List = codeDataStore.get("common.suppSizeB," + state.funPurUseNo + "," + code);
																setState({
																	...state,
																	bizKindCd1: code,
																	bizKindCd2List: bizKindCd2List
																});
															})();
														}
														// codeDataStore.read("common.suppSizeB," + funPurUseNo + "," + value).then(() => {
														// 	console.log("common.suppSizeB", codeDataStore.get("common.suppSizeB," + funPurUseNo + "," + value))
														// });
													}
												}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">과제분류(소분류)</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												codeData={state.bizKindCd2List}
												/*codeData={codeDataStore.get("common.suppSizeB," + funPurUseNo + "," + bizKindCd1)}*/
												value={state.bizKindCd2}
												valueChanged={(value) => setState({...state, bizKindCd2:String(value)})}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section className="fund-section">
						<h3 className="section-title hz-item mb15">기금정산방식</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<div className="fo-key">
										<span>기금정산방식</span>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap15">
											<label htmlFor="rd-1-1" className="ip-rd-label">
												<input name="rd-1" id="rd-1-1" className="ip-rd" type="radio" value='N' checked={state.foreTskYn !== 'Y'} onChange={(value) => setState({...state, foreTskYn:'N'})}/>
												<span className="check"></span>
												<span className="txt">사후정산</span>
											</label>
											<label htmlFor="rd-1-2" className="ip-rd-label">
												<input name="rd-1" id="rd-1-2" className="ip-rd" type="radio" value='Y' checked={state.foreTskYn === 'Y'} onChange={(value) => setState({...state, foreTskYn:'Y'})}/>
												<span className="check"></span>
												<span className="txt">선지급</span>
											</label>
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-gap5 mb15">
							<h3 className="section-title">지원내용 및 기대효과</h3>
							<button type="button" className="button-tooltip" data-tooltip-id="tooltip4">도움말</button>
							<Tooltip
								id="tooltip4"
								disableStyleInjection={true}
								place={"bottom-start"}
								className="tooltip-conts"
							>
								<div className="msg">지원계획 내용과 지원을 통해 기대되는 효과 기입</div>
							</Tooltip>
						</div>
						<form name="" action="" method="" className=" mb30">
							<div className="tb tb-narrow mb15">
								<table>
									<caption></caption>
									<colgroup>
										<col width="200px"/>
										<col/>
									</colgroup>
									<tbody>
									<tr>
										<th scope="row"><span className="th-req">과제개요</span></th>
										<td>
											<div className="ta-group w100p">
												{/*<textarea rows={3} className="ta-ip" value={suppCont} placeholder="과제에 대한 개요를 입력하세요."/>*/}
												<UITextArea className={'ta-ip'} value={state.suppCont} valueChanged={(value) => { setState({...state, suppCont:value}) }}/>
											</div>
										</td>
									</tr>
									<tr>
										<th scope="row"><span className="th">정성효과</span></th>
										<td>
											<div className="ta-group w100p">
												{/*<textarea rows={3} className="ta-ip" value={exeEffDesc} placeholder="거래관계 향상에 대한 의견을 자유롭게 입력하세요"/>*/}
												<UITextArea className={'ta-ip'} value={state.exeEffDesc} valueChanged={(value) => { setState({...state, exeEffDesc:value}) }}/>
											</div>
										</td>
									</tr>
									<tr>
										<th scope="row">기대효과</th>
										<td>
											<div className="fo fo-col2">
												<div className="inner">
													{ state.queList.length != 0 && state.queList.map((que, idx) => (
														<div className="fo-item" key={que.QUA_ID}>
															<p className="fo-key">{ que.QUA_TEXT }</p>
															<div className="fo-value">
																<UIInput
																	className={'tf tf-md  w100p'}
																	value={que.VALUE}
																	valueChanged={(value) => {
																		let newList:any = [...state.queList];
																		newList[idx].VALUE = value;
																		setState({...state, qList:newList});
																	}}
																	placeholder={''} />
															</div>
														</div>
													))}
												</div>
											</div>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
							<div className="tx-msg"><span className="fc-pri">※ 기대효과(정성), 기대효과(정량)에 최소 1개 이상의 항목에 입력해 주세요.</span>
							</div>
						</form>
					</section>
					<section className="fund-section">
						<h3 className="section-title mb15">지원 대상</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<div className="fo-key">
										<span className="req">중소기업 지원 수</span>
										<button type="button" className="button-tooltip"
												data-tooltip-id="tooltip5">도움말
										</button>
										<Tooltip
											id="tooltip5"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">수혜받는 중소기업 수를 기입</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
											<UIInput className={'tf tf-md ta-right w100p'} value={state.suppCorpCnt} valueChanged={(value) => { setState({...state, suppCorpCnt:value}) }} placeholder={''}/>
											<p className="tx-msg hz-item">개사 (수혜 받을 중소기업 수 입력)</p>
										</div>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">중소기업 외 지원 수</p>
									<div className="fo-value">
										<div className="hz-root hz-gap5">
											<UIInput className={'tf tf-md ta-right w100p'} value={state.otherSuppCorpCnt} valueChanged={(value) => { setState({...state, otherSuppCorpCnt:value}) }} placeholder={''}/>
											<p className="tx-msg hz-item">개사 (※상생협력기금은 중견기업, 대기업 및 특수관계인 등에게 지원불가합니다.)</p>
										</div>
									</div>
								</div>
								<div className="fo-item fo-m-1-3">
									<div className="fo-key">
										<span className="req">수행기관</span>
										<button type="button" className="button-tooltip" data-tooltip-id="tooltip6">도움말
										</button>
										<Tooltip
											id="tooltip6"
											disableStyleInjection={true}
											place={"bottom-start"}
											className="tooltip-conts"
										>
											<div className="msg">
												효율적인 사업수행을 위하여 출연기업이 선정한 대행기관(기업)을 의미하며, <br/>
												협력재단이 수행기관에게 직접 지급하는 경우에만 사업자등록증의 상호명을 기입<br/>
												(수행기관 변경 및 추가 시 사업변경 신청 필수)
											</div>
										</Tooltip>
									</div>
									<div className="fo-value">
										<div className="hz-root hz-gap10 w100p">
											<div className="sl sl-md w556">
												<select name={'open2102Sel'} value={state.open2102} onChange={handleChange}>
													{ state.tskBizCd.indexOf('O') == -1 && <option value={''}>수행기관 없음</option> }
													{ state.tskBizCd.indexOf('O') == -1 && <option value={'open'}>기타 수행기관 찾기</option> }
													{ state.tskBizCd.indexOf('O') != -1 && <option value={''}>대중소기업농어업협력재단</option> }
												</select>
											</div>
											{state.open2102 !== '' &&
												<div className="hz-root hz-gap5 w-auto">
													<UIInput className={'tf tf-md hz-item hz-fg w400'} value={state.selectCorpList} placeholder={'기업명'}/>
													<Button color='pri-o2' size="md" onClick={() => setModal2102IsOpen(true)}>찾기</Button>
												</div>
											}
										</div>
									</div>
								</div>
							</div>
						</form>
					</section>

					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<div className="hz-root hz-gap10">
								<h3 className="section-title">지원 항목 별 지원금</h3>
								<p className="tx-msg"><span className="fc-pri">※ 지원금은 최소 1개 이상을 입력해야 합니다. </span></p>
							</div>
							<div className="hz-root hz-gap5">
								<Button color='pri-o' size="sm" onClick={addList}>행추가</Button>
								<Button color='gray-o' size="sm" onClick={deleteList}>행삭제</Button>
							</div>
						</div>
						<form name="" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="60px"/>
										<col width="385px"/>
										<col width="385px"/>
										<col width="385px"/>
										<col/>
									</colgroup>
									<thead>
									<tr>
										<th>
											<label htmlFor="ch-all" className="hz-item ip-ch-label ip-ch-18">
												<input id="ch-all" className="ip-ch" type="checkbox" name={'ch-all'} checked={isAllChk} onChange={(e) => checkBoxHandler(e)}/>
												<span className="check"></span>
											</label>
										</th>
										<th scope="col">지원항목</th>
										<th scope="col">산출근거</th>
										<th scope="col">증빙방법</th>
										<th scope="col">금액(원)</th>
									</tr>
									</thead>
									<tbody>
									{state.amtList.map((amt, idx) => (
										<tr key={idx}>
											<td>
												<label htmlFor={'ch-t1' + idx} className="hz-item ip-ch-label ip-ch-18">
													<input id={'ch-t1' + idx} className="ip-ch" name={'isChk' + idx} type="checkbox" checked={amt.checked} onChange={(e) => checkBoxHandler(e)}/>
													<span className="check"></span>
												</label>
											</td>
											<td>
												<UIInput className={'tf tf-md  w100p'}
														 value={amt.SUPP_ITEM}
														 valueChanged={(value) => {
															 changeVal(value, 'item', idx);
														 }}
														 placeholder={'지원항목을 입력하세요(입력수제한없음)'}
												/>
											</td>
											<td>
												<UIInput className={'tf tf-md  w100p'}
														 value={amt.CALC_BASIS}
														 valueChanged={(value) => {
															 changeVal(value, 'basis', idx);
														 }}
														 placeholder={'산출근거를 입력하세요(입력수제한없음)'}
												/>
											</td>
											<td>
												<UIInput className={'tf tf-md  w100p'}
														 value={amt.PROF_MATH}
														 valueChanged={(value) => {
															 changeVal(value, 'math', idx);
														 }}
														 placeholder={'증빙방법을 입력하세요(입력수제한없음)'}
												/>
											</td>
											<td>
												<div className="hz-root hz-gap5 w100p">
													<div className="tf-unit hz-item hz-fg">
														<UIInput className={'tf tf-md ta-right'}
																 value={StringUtil.formatNumber(Number(amt.SUPP_AMT)) || ""}
																 valueChanged={(value) => {
																	 let tmpVal = value.replace(/[^0-9]/g, "");
																	 changeVal(tmpVal, 'amt', idx);
																 }}
																 placeholder={'지원금액을 입력하세요(숫자만입력)'}
														/>
														<span className="u">원</span>
													</div>
												</div>
											</td>
										</tr>
									))}
									</tbody>
								</table>
							</div>
							<div className="tb-total">
								<div className="tb-total-items">지원 항목별 합계금액(원)</div>
								<div className="tb-total-items">
									<div className="fund-form-items tf-unit">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(state.totalAmt)) || "0"} placeholder={''} readOnly={true}/>
										<span className="u">원</span>
									</div>
									<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(state.totalAmt + "") ?
										StringUtil.numKorPattern(state.totalAmt) + " 원" : "원"})</span>
									</p>
								</div>
							</div>
						</form>
					</section>
					
					<section className="fund-section">
						<div className="hz-root hz-sb mb15">
							<div className="hz-root hz-gap10">
								<h3 className="section-title">출연잔액 외 추가과제승인 신청금액</h3>
							</div>
							<div className="hz-root hz-gap5">
								<Button color='pri-o' size="sm" onClick={addList2}>행추가</Button>
								<Button color='gray-o' size="sm" onClick={deleteList2}>행삭제</Button>
							</div>
						</div>
						<form className="mb15" action="" method="">
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="60px"/>
										<col width="385px"/>
										<col width="385px"/>
										<col width="385px"/>
										<col/>
									</colgroup>
									<thead>
									<tr>
										<th>
											<label htmlFor="ch-all2" className="hz-item ip-ch-label ip-ch-18">
												<input id="ch-all2" className="ip-ch" type="checkbox" name={'ch-all2'} checked={isAllChk2} onChange={(e) => addCheckBoxHandler(e)}/>
												<span className="check"></span>
											</label>
										</th>
										<th scope="col">지원항목</th>
										<th scope="col">산출근거</th>
										<th scope="col">증빙방법</th>
										<th scope="col">금액(원)</th>
									</tr>
									</thead>
									<tbody>
									{state.addAmtList.map((amt, idx) => (
										<tr key={idx}>
											<td>
												<label htmlFor={'ch-t2' + idx} className="hz-item ip-ch-label ip-ch-18">
													<input id={'ch-t2' + idx} className="ip-ch" name={'isChk' + idx} type="checkbox" checked={amt.checked} onChange={(e) => addCheckBoxHandler(e)}/>
													<span className="check"></span>
												</label>
											</td>
											<td>
												<UIInput className={'tf tf-md  w100p'}
														 value={amt.ADD_SUPP_ITEM}
														 valueChanged={(value) => {
															 changeVal2(value, 'item', idx);
														 }}
														 placeholder={'지원항목을 입력하세요(입력수제한없음)'}
												/>
											</td>
											<td>
												<UIInput className={'tf tf-md  w100p'}
														 value={amt.ADD_CALC_BASIS}
														 valueChanged={(value) => {
															 changeVal2(value, 'basis', idx);
														 }}
														 placeholder={'산출근거를 입력하세요(입력수제한없음)'}
												/>
											</td>
											<td>
												<UIInput className={'tf tf-md  w100p'}
														 value={amt.ADD_PROF_MATH}
														 valueChanged={(value) => {
															 changeVal2(value, 'math', idx);
														 }}
														 placeholder={'증빙방법을 입력하세요(입력수제한없음)'}
												/>
											</td>
											<td>
												<div className="hz-root hz-gap5 w100p">
													<div className="tf-unit hz-item hz-fg">
														<UIInput className={'tf tf-md ta-right'}
																 value={StringUtil.formatNumber(Number(amt.ADD_SUPP_AMT)) || ""}
																 valueChanged={(value) => {
																	 let addTmpVal = value.replace(/[^0-9]/g, "");
																	 changeVal2(addTmpVal, 'amt', idx);
																 }}
																 placeholder={'지원금액을 입력하세요(숫자만입력)'}
														/>
														<span className="u">원</span>
													</div>
												</div>
											</td>
										</tr>
									))}
									</tbody>
								</table>
							</div>
							<div className="tb-total">
								<div className="tb-total-items">지원 항목별 합계금액(원)</div>
								<div className="tb-total-items">
									<div className="fund-form-items tf-unit">
										<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(state.addTotalAmt)) || "0"} placeholder={''} readOnly={true}/>
										<span className="u">원</span>
									</div>
									<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(state.addTotalAmt + "") ?
										StringUtil.numKorPattern(state.addTotalAmt) + " 원" : "원"})</span>
									</p>
								</div>
							</div>
						</form>
						<div className="tx-msg"><span className="fc-pri">※ 과제승인시점 기준으로 출연잔액이 부족한데, 승인심사를 받고자하는 경우에만 작성해주세요. 추가출연계획이 반드시 포함되어야합니다.</span></div>
					</section>
					<section className="fund-section">
						<div className="hz-root hz-gap5 mb15">
							<h3 className="section-title">첨부파일</h3>
							<button type="button" className="button-tooltip" data-tooltip-id="tooltip7">도움말</button>
							<Tooltip
								id="tooltip7"
								disableStyleInjection={true}
								place={"bottom-start"}
								className="tooltip-conts"
							>
								<div className="msg">
									<h6 className="tooltip-title">과제 신청 시 첨부 서류</h6>
									<ul>
										<li>1. 운영규정 별지 제2호 동반성장 투자재원 과제신청서(과제요약서 포함)
											<ul className="list-group">
												<li>서면 : 지급신청서(서면) 클릭하여 지급신청서 출력 후 직인을 찍고 스캔하여 첨부문서에 등록하셔야 합니다.</li>
												<li>전자인증 : 기업용 공인인증서를 이용하여 지급신청서(전자인증) 을 클릭하여 인증이 완료 되면 됩니다. <br/>별도 첨부
													문서는 없습니다.
												</li>
											</ul>
										</li>
										<li>2. 세부사업계획서(완료심사의 경우, 사업완료보고서)</li>
										<li>3. 수행기관 사업자등록증(해당시)</li>
										<li>4. 기타 심사에 필요하다고 판단되는 경우, 추가 서류를 요청 드릴 수 있습니다.</li>
									</ul>
								</div>
							</Tooltip>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								{ state.elecApprYn == 'N' &&
									<div className="fo-item fo-m-1-3 req">
										<p className="fo-key">과제 신청서</p>
										<div className="fo-value">
											<div className="fund-form-group">
												<div className="fund-form-items mr20">
													<div className="hz-root hz-gap8 w100p">
														<UIInput className={'tf tf-md hz-item grow'} value={reqFileNm} placeholder={'파일을 첨부해 주세요.'}/>
														<div className="hz-root hz-gap8">
															<Button color='pri-o2' size="md" onClick={() => reqModal('REQ')}>찾기</Button>
															<Button color='gray-o' size="md" onClick={() => fileDelete('REQ')}>삭제</Button>
														</div>
													</div>
												</div>
												<Button color='gray-o' size="md" onClick={() => downloadButtonClickHandler('REQ')}>양식 다운로드</Button>
											</div>
										</div>
									</div>
								}
								{ state.elecApprYn == 'Y' &&
									<div className="fo-item fo-m-1-3 req">
										<p className="fo-key">과제 신청서</p>
										<div className="fo-value">
											전자인증을 완료하였습니다.
										</div>
									</div>
								}

								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">과제 계획서</p>
									<div className="fo-value">
										<div className="fund-form-group">
											<div className="fund-form-items mr20">
												<div className="hz-root hz-gap8 w100p">
													<UIInput className={'tf tf-md hz-item grow'} value={planFileNm} placeholder={'파일을 첨부해 주세요.'}/>
													<div className="hz-root hz-gap8">
														<Button color='pri-o2' size="md" onClick={() => reqModal('PLAN')}>찾기</Button>
														<Button color='gray-o' size="md" onClick={() => fileDelete('PLAN')}>삭제</Button>
													</div>
												</div>
											</div>
											{/*<Button color='gray-o' size="md" onClick={() => downloadButtonClickHandler('PLAN')}>양식 다운로드</Button>*/}
										</div>
									</div>
								</div>
								{ state.open2102 == 'open' &&
									<div className="fo-item fo-m-1-3 req">
										<p className="fo-key">수행기관 사업자 등록증<br/>(수행기관 해당시만)</p>
										<div className="fo-value">
											<div className="fund-form-group">
												<div className="fund-form-items mr20">
													<div className="hz-root hz-gap8 w100p">
														<UIInput className={'tf tf-md hz-item grow'} value={bizFileNm} placeholder={'파일을 첨부해 주세요.'}/>
														<div className="hz-root hz-gap8">
															<Button color='pri-o2' size="md" onClick={() => reqModal('BIZ')}>찾기</Button>
															<Button color='gray-o' size="md" onClick={() => fileDelete('BIZ')}>삭제</Button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								}
							</div>
						</form>
						<p className="tx-msg mb15"><span className="fc-pri">※ 항목 외 기타 파일들은 아래 파일 첨부를 이용해 주세요.</span></p>
						<UI.FileUpload
							onCreationComplete={onCreationComplete}
							onUploadComplete={onUploadComplete}
							attrs={{
							//	MaxTotalFileCount: "3",
								ExtensionAllowOrLimit: "1",
								Width:"100%",
								Views: "thumbs"
							}}
							value={state.otherFiles}
						/>
					</section>
					{state.tskReqStsCd == 'E' &&
						<section className="fund-section">
							<div className="hz-root hz-gap10 mb25">
								<h3 className="section-title">변경이력 선택</h3>
								<p className="tx-msg"><span
									className="fc-pri">※ 아래 항목 중 수정하신 내용을 선택하시면 수정된 내역을 확인하실 수 있습니다.</span></p>
							</div>
							<form name="" action="" method="">
								<div className="hz-root hz-gap24 mb15">
									<label htmlFor="ch-1" className="hz-item ip-ch-label ip-ch-18">
										<input id="ch-1" className="ip-ch" type="checkbox" checked={state.isUA} onChange={(e) => checkBoxHandlerChange(e)}/>
										<span className="check"></span>
										<span className="txt">지원금액 변경</span>
									</label>
									<label htmlFor="ch-2" className="hz-item ip-ch-label ip-ch-18">
										<input id="ch-2" className="ip-ch" type="checkbox" checked={state.isUD} onChange={(e) => checkBoxHandlerChange(e)}/>
										<span className="check"></span>
										<span className="txt">지원기간 변경</span>
									</label>
									<label htmlFor="ch-3" className="hz-item ip-ch-label ip-ch-18">
										<input id="ch-3" className="ip-ch" type="checkbox" checked={state.isUE} onChange={(e) => checkBoxHandlerChange(e)}/>
										<span className="check"></span>
										<span className="txt">기타 변경사유</span>
									</label>
								</div>
								<div className="tb tb-narrow mb15">
									<table>
										<caption></caption>
										<colgroup>
											<col/>
											<col width="40%"/>
											<col width="40%"/>
										</colgroup>
										<thead>
										<tr>
											<th scope="col">구분</th>
											<th scope="col">기준</th>
											<th scope="col">변경</th>
										</tr>
										</thead>
										<tbody>
										{state.isUA &&
											<tr>
												<td>지원금액 변경</td>
												<td>
													<div className="tf-unit w100p">
														<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(state.oldTskInfo.TOT_AMT)) || "0"} placeholder={''} readOnly={true}/>
														<span className="u">원</span>
													</div>
												</td>
												<td>
													<div className="tf-unit w100p">
														<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(state.totalAmt)) || "0"} placeholder={''} readOnly={true}/>
														<span className="u">원</span>
													</div>
												</td>
											</tr>
										}
										{state.isUD &&
											<tr>
												<td>지원기간 변경</td>
												<td>
													<div className="hz-root hz-gap5 w100p">
														{dateToStr(state.oldTskInfo.TSK_ST_DATE)}
														<span className="hz-item">~</span>
														{dateToStr(state.oldTskInfo.TSK_EN_DATE)}
													</div>
												</td>
												<td>
													<div className="hz-root hz-gap5 w100p">
														{dateToStr(state.tskStDate)}
														<span className="hz-item">~</span>
														{dateToStr(state.tskEnDate)}
													</div>
												</td>
											</tr>
										}
										{state.isUE &&
											<tr>
												<td>기타 변경 사유</td>
												<td colSpan={2}>
													<div className="ta-group w100p">
														<UITextArea className={'ta-ip'} value={state.judgeCmtUE} valueChanged={(value) => { setState({...state, judgeCmtUE:value}) }}/>
													</div>
												</td>
											</tr>
										}
										</tbody>
									</table>
								</div>
								<p className="tx-msg">※ 안내사항 : 위에서 변경될 내용에 대해 변경하시고 체크박스를 선택하시면 변경내용이 자동으로 적용됩니다.</p>
							</form>
						</section>
					}
					{state.tskReqStsCd == 'E' && (state.isUA || state.isUD) &&
						<section className="fund-section">
							<div className="hz-root hz-gap10 mb25">
								<h3 className="section-title">변경사유 입력</h3>
							</div>
							<form name="" action="" method="">
								<div className="tb tb-narrow mb15">
									<table>
										<caption></caption>
										<colgroup>
											<col width="200px"/>
											<col/>
										</colgroup>
										<tbody>
										{ state.isUA &&
											<tr>
												<th scope="row"><span className="th-req">지원금액 변경사유</span></th>
												<th scope="row">
													<div className="ta-group w100p">
														<UITextArea className={'ta-ip'} value={state.judgeCmtUA} valueChanged={(value) => { setState({...state, judgeCmtUA:value}) }}/>
													</div>
												</th>
											</tr>
										}
										{ state.isUD &&
											<tr>
												<th scope="row"><span className="th-req">지원기간 변경사유</span></th>
												<th scope="row">
													<div className="ta-group w100p">
														<UITextArea className={'ta-ip'} value={state.judgeCmtUD} valueChanged={(value) => { setState({...state, judgeCmtUD:value}) }}/>
													</div>
												</th>
											</tr>
										}
										</tbody>
									</table>
								</div>
							</form>
						</section>
					}

					<section className="fund-section">
						<h3 className="section-title mb15">기업 정보</h3>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.corpNm} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">법인사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.corpRegNo} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.bizCrpFormat(state.bizNo)} placeholder={''} readOnly={true}/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.personNm} valueChanged={(value) => { setState({...state, personNm:value}) }} placeholder={''}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">직급</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.posiNm} valueChanged={(value) => { setState({...state, posiNm:value}) }} placeholder={''}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">부서</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.deptNm} valueChanged={(value) => { setState({...state, deptNm:value}) }} placeholder={''}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">이메일</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.emailAdres} valueChanged={(value) => { setState({...state, emailAdres: value}) }} placeholder={''}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={StringUtil.telephoneFormat(state.ofcTelNo)} valueChanged={(value) => { setState({...state, ofcTelNo: value}) }} placeholder={''}/>
									</div>
								</div>
							</div>
						</form>
					</section>
					<div className="hz-root hz-right hz-gap10 mt30">
						<Button color="gray-o" size="md" onClick={() => moveBack()}>취소</Button>
						<Button color="pri" size="md" onClick={() => saveTsk(false)}>저장</Button>
						<Button color="gray-o" size="md" onClick={() => moveBack2105()}>목록</Button>
					</div>
				</main>
			</div>
			{/* modal - 출연금액 선택 */}
			{/* modal - 출연사업 선택 */}
			<ModalPopup
				open={modal2139IsOpen}
				title="출연사업 선택"
				size="mid"
				onClose={() => onClose('2139')}
				onAfterOpen={() => onAfterOpen('2139')}
			>
				<div className="modal-con">
					<div className="modal-tskana">
						<form className="fo fo-col2 mb15" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-item fo-m-1-3">
									<p className="fo-key">출연사업</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												codeData={codeDataStore.get("cfms.portalBizCdList")}
												value={state.bizCd}
												valueChanged={(value) => setState({...state, bizCd: String(value)})}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
							</div>
						</form>
						<div className="hz-root hz-center mb30">
							<Button color="pri" size="md" onClick={() => initSheet_modal()}>조회</Button>
						</div>
						<div className="tb-top">
							<div>
								<p className="tx fc-black">총 <em className="fw500">{state.totalRowCnt}</em>건</p>
							</div>
							<div className="hz-root hz-gap8">
								<div className="sl sl-sm w120">
									<select name="showRowCnt" id="showRowCnt" value={state.showRowCnt} onChange={(handleSelect)}>
										<option value="20">20개씩보기</option>
										<option value="50">50개씩보기</option>
										<option value="100">100개씩보기</option>
										<option value="200">200개씩보기</option>
										<option value="500">500개씩보기</option>
										<option value="1000">1000개씩보기</option>
									</select>
								</div>
							</div>
						</div>
						<div id="modal_2139_List">[D] IBSHEET 영역</div>
						<div id="pageNavi" className="pg"></div>
					</div>
				</div>
			</ModalPopup>

			{/* modal - 수행 기관 찾기 */}
			<ModalPopup
				open={modal2102IsOpen}
				title="수행 기관 찾기"
				size="lg"
				onClose={() => onClose('2102')}
				onAfterOpen={() => onAfterOpen('2102')}
			>
				<div className="modal-con">
					<div className="modal-tskana">
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item">
									<p className="fo-key">사업자번호</p>
									<div className="fo-value">
										<UIInput type={'number'} className={'tf tf-md w100p'} value={state.bizNo2102} valueChanged={(value) => { setState({...state, bizNo2102: value}) }} placeholder={'숫자만 입력'} attrs={{maxLength:10}}/>
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.corpNm2102} valueChanged={(value) => { setState({...state, corpNm2102:value}) }} placeholder={'기업명을 입력하세요.'}/>
									</div>
								</div>
							</div>
						</form>
						<div className="hz-root hz-center hz-gap8 mb30">
							<Button color="pri" size="md" onClick={() => initSheet_modal()}>조회</Button>
						</div>
						<div className="approval-gen">
							<div className="approval-gen-member">
								<h3 className="tx tx-bd1">수행기관목록</h3>
								<div className="box">
									<div id="modal_2102_List">[D] IBSHEET 영역</div>
								</div>
								<div id="pageNavi" className="pg"></div>
							</div>
							<div className="approval-ctr">
								<button type="button" className="bt bt-right-ico" data-size="md" data-color="gray-o" onClick={() => addRow('right')}>&gt;</button>
								<button type="button" className="bt bt-left-ico" data-size="md" data-color="gray-o" onClick={() => addRow('left')}>&lt;</button>
							</div>
							<div className="approval-gen-selected">
								<div className="hz-root hz-sb">
									<h3 className="tx tx-bd1">선택된 수행기관</h3>
									<Button color="gray-o" size="sm" onClick={() => addRow('reset')}>선택초기화</Button>
								</div>
								<div className="box">
									<div id="modal_2102_Listright">[D] IBSHEET 영역</div>
								</div>
								<div id="pageNaviRight" className="pg"></div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-bottom">
					<Button color="pri-o" size="md" onClick={() => setModal2103IsOpen(true)}>수행기관 신규등록</Button>
					<Button color="gray-o" size="md" onClick={() => onClose('2102')}>취소</Button>
					<Button color="pri" size="md" onClick={() => savePerfCorpList()}>적용</Button>
				</div>
			</ModalPopup>
			{/* modal - 수행기관 신규등록 */}
			<ModalPopup
				open={modal2103IsOpen}
				title="수행기관 신규등록"
				size="lg"
				onClose={() => onClose('2103')}
			>
				<div className="modal-con">
					<div className="modal-tskana">
						<div className="ta-right mb10">
							<p className="tx-msg"><span className="fc-pri">*</span>&nbsp;필수 입력</p>
						</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.corpNm2103} valueChanged={(value) => setState({...state, corpNm2103: String(value)})} placeholder={'기업명을 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">사업자등록번호</p>
									<div className="fo-value">
										<UIInputMask
											mask={"999-99-99999"}
											className={'tf tf-md w100p'} 
											value={state.bizNo2103}
											valueChanged={(value) => setState({...state, bizNo2103: value})}
											rules={["required"]}
										/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">대표자명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.ceoNm2103} valueChanged={(value) => setState({...state, ceoNm2103: String(value)})} placeholder={'대표자명을 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">설립일자</p>
									<div className="fo-value">
										<div className="w215">
											<UIDatePicker value={state.estaDate2103} valueChanged={(value) => setState({...state, estaDate2103:value})}/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">설립형태</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												codeData={codeDataStore.get("[EFC]")}
												value={state.estaFormCd2103}
												valueChanged={(value) => setState({...state, estaFormCd2103: String(value)})}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">기업규모</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												codeData={codeDataStore.get("[SCS]")}
												value={state.corpSizeCd2103}
												valueChanged={(value) => setState({...state, corpSizeCd2103: String(value)})}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">업종</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												codeData={codeDataStore.get("[INC]")}
												value={state.induCd2103}
												valueChanged={(value) => setState({...state, induCd2103: String(value)})}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.personNm2103} valueChanged={(value) => setState({...state, personNm2103: String(value)})}  placeholder={'담당자명을 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item ">
									<p className="fo-key">메일주소</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.emailAdres2103} valueChanged={(value) => setState({...state, emailAdres2103: String(value)})}  placeholder={'메일주소를 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">일반전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.ofcTelNo2103} valueChanged={(value) => setState({...state, ofcTelNo2103: String(value)})}  placeholder={'일반전화번호를 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">휴대폰번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.hpNo2103} valueChanged={(value) => setState({...state, hpNo2103: String(value)})}  placeholder={'일반전화번호를 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">사업자 등록증</p>
									<div className="fo-value">
										<div className='w100p'>
											<UI.FileUpload
												onCreationComplete={onCreationComplete2103}
												onUploadComplete={onUploadComplete2103}
												className={'w100p'}
												attrs={{
													MaxTotalFileCount: "1",
													ExtensionAllowOrLimit: "1",
													Width:"100%",
													Views: "thumbs"
												}}
											/>
										</div>
									</div>
								</div>
							</div>

						</form>
					</div>
				</div>
				<div className="modal-bottom">
					<Button color="gray-o" size="md" onClick={() => onClose('2103')}>취소</Button>
					<Button color="pri" size="md" onClick={() => saveCorp(false)}>저장</Button>
				</div>
			</ModalPopup>
			{/* modal - 수행기관 관리 */}
			<ModalPopup
				open={modal2104IsOpen}
				title="수행기관 관리"
				size="lg"
				onClose={() => onClose('2104')}
			>
				<div className="modal-con">
					<div className="modal-tskana">
						<div className="ta-right mb8 tx-msg"><span className="fc-pri">＊</span> 필수 입력</div>
						<form className="fo fo-col2" name="" action="" method="">
							<div className="inner">
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">기업명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.corpNm2104} valueChanged={(value) => setState({...state, corpNm2104: String(value)})} placeholder={'기업명을 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">사업자등록번호</p>
									<div className="fo-value">
										<UIInputMask
											mask={"999-99-99999"}
											className={'tf tf-md w100p'} 
											value={state.bizNo2104}
											valueChanged={(value) => setState({...state, bizNo2104: value})}
											rules={["required"]}
										/>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">대표자명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.ceoNm2104} valueChanged={(value) => setState({...state, ceoNm2104:String(value)})} placeholder={'대표자명을 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">설립일자</p>
									<div className="fo-value">
										<div className="w215">
											<UIDatePicker value={state.estaDate2104} valueChanged={(value) => setState({...state, estaDate2104: value})}/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">설립형태</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												codeData={codeDataStore.get("[EFC]")}
												value={state.estaFormCd2104}
												valueChanged={(value) => setState({...state, estaFormCd2104: String(value)})}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">기업규모</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												codeData={codeDataStore.get("[SCS]")}
												value={state.corpSizeCd2104}
												valueChanged={(value) => setState({...state, corpSizeCd2104: String(value)})}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">업종</p>
									<div className="fo-value">
										<div className="sl sl-md w100p">
											<UISelect
												codeData={codeDataStore.get("[INC]")}
												value={state.induCd2104}
												valueChanged={(value) => setState({...state, induCd2104: String(value)})}
												firstName={"sel"}
											/>
										</div>
									</div>
								</div>
								<div className="fo-item req">
									<p className="fo-key">담당자명</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.personNm2104} valueChanged={(value) => setState({...state, personNm2104: String(value)})} placeholder={'담당자명을 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item ">
									<p className="fo-key">메일주소</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.emailAdres2104} valueChanged={(value) => setState({...state, emailAdres2104: String(value)})} placeholder={'메일주소를 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">일반전화번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.ofcTelNo2104} valueChanged={(value) => setState({...state, ofcTelNo2104:String(value)})} placeholder={'일반전화번호를 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item">
									<p className="fo-key">휴대폰번호</p>
									<div className="fo-value">
										<UIInput className={'tf tf-md w100p'} value={state.hpNo2104} valueChanged={(value) => setState({...state, hpNo2104:String(value)})} placeholder={'일반전화번호를 입력하세요.'} />
									</div>
								</div>
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">사업자 등록증</p>
									<div className="fo-value">
										<div className='w100p'>
											<UI.FileUpload
												onCreationComplete={onCreationComplete2104}
												onUploadComplete={onUploadComplete2104}
												attrs={{
													MaxTotalFileCount: "1",
													ExtensionAllowOrLimit: "1",
													Width:"100%",
													Views: "thumbs"
												}}
												value={bizLicFileValue}
											/>
										</div>
									</div>
								</div>
							</div>
						</form>
						<section className="fund-section mt30">
							<h3 className="section-title mb15">등록 정보</h3>
							<div className="tb tb-narrow">
								<table>
									<caption></caption>
									<colgroup>
										<col width="120px" />
										<col />
										<col width="240px" />
									</colgroup>
									<thead>
									<tr>
										<th scope="col">순번</th>
										<th scope="col">등록일시</th>
										<th scope="col">등록자</th>
									</tr>
									</thead>
									<tbody>
									{state.history2104 != null? state.history2104.map((history, index) => (
											<tr key={index}>
												<td>{index + 1}</td>
												<td>{history.REG_DATE}</td>
												<td>{history.REG_USERNM}</td>
											</tr>
										))
										: "데이터가 없습니다."}
									</tbody>
								</table>
							</div>
						</section>
					</div>
				</div>
				<div className="modal-bottom">
					<Button color="gray-o" size="md" onClick={() => onClose('2104')}>취소</Button>
					<Button color="pri" size="md" onClick={() => updateCorp(false)}>저장</Button>
				</div>
			</ModalPopup>
		</PageContainer>
	);
}
export default ContentsContainer;